{
    "cli": {
        "compileRemoved": "The compile command has been removed. `magic-md compile ...` and `magic-md <file>` are no longer supported. The CLI now only provides connect and completion.",
        "usage": "Commands:\n  connect                    Start a local Engine Gateway for the Web frontend\n  completion <bash|zsh|fish> Output a shell completion script\n  help                       Show help\n  -v, --version              Show version information\n\nConnect Options:\n      --port <port>          Listening port (defaults to gateway.toml, otherwise 3721)\n      --host <host>          Listening host (defaults to gateway.toml, otherwise 127.0.0.1)\n      --lan                  Listen on the LAN and advertise to Magic MD Play via Bonjour\n      --dir <dir>            Engine working directory (defaults to the current directory)\n      --docs-dir <dir>       Document/workspace directory to expose as an allowed access root\n      --no-implicit-workspace Do not automatically expose --dir as an allowed access root\n      --token <token>        Enable Bearer Token authentication\n      --allow-sidecar <id>   Allowed sidecar, can be repeated; allows all sidecars when omitted\n      --cloud-plugin-source <source> Cloud plugin source URL or JSON object; can be repeated"
    },
    "editor": {
        "app.commandPalette": "Command Palette",
        "appLog.crossWindowSyncInitFailed": "Cross-window sync initialization failed: {message}",
        "appLog.detachedReceivedTabTransfer": "DetachedWindow: received tab transfer \"{title}\"",
        "appLog.engine.connectFailed": "Engine connection failed: {message}",
        "appLog.engine.connecting": "Connecting Engine ({mode})...",
        "appLog.engine.devConnectFailed": "Dev mode Engine connection failed: {message}",
        "appLog.engine.devWaiting": "Dev mode: waiting for Engine to start automatically...",
        "appLog.engine.startFailed": "Engine startup failed: {message}",
        "appLog.engineNotConfigured": "Engine is not configured. Configure the Engine connection at the bottom of the sidebar.",
        "appLog.engineStateChangedReloadPlugins": "Engine state changed. Reloading plugins (mode={mode}, connected={connected})",
        "appLog.loadPlugins.builtinLocalDir": "Builtin mode: loading plugins from local directory: {path}",
        "appLog.loadPlugins.builtinMissingEngineDir": "Builtin mode but engineDir is not configured",
        "appLog.loadPlugins.devSource": "Dev mode: loading plugins from source",
        "appLog.loadPlugins.devUnsupported": "Production builds do not support dev-mode source plugin loading. Switch to builtin or local.",
        "appLog.loadPlugins.gateway": "Remote mode: loading plugins from Gateway: {url}",
        "appLog.loadPlugins.noGatewayPlugins": "Gateway has no available plugins",
        "appLog.loadPlugins.noLocalPlugins": "No local plugins found",
        "appLog.loadPlugins.nonePreviewSource": "Engine is not configured. Loading plugins from source for preview mode.",
        "appLog.mainReceivedTabTransfer": "Main window: received tab transfer \"{title}\"",
        "appLog.mode.builtin": "builtin mode",
        "appLog.mode.local": "local mode",
        "appLog.web.loadPlugins.devSource": "Dev mode: loading plugin UI from source. Engine still uses the current connection.",
        "appLog.web.loadPlugins.gateway": "Loading plugins from Gateway: {url}",
        "appLog.web.loadPlugins.noGatewayPlugins": "Gateway has no available plugins. Make sure Gateway is running and plugins are built.",
        "category.file": "File",
        "category.general": "General",
        "category.pane": "Pane",
        "category.plugin": "Plugin",
        "category.search": "Search",
        "category.sidebar": "Sidebar",
        "category.view": "View",
        "command.empty": "No commands found",
        "command.file.clearRecent": "Clear Recent Items",
        "command.file.closeAllTabs": "Close All Tabs",
        "command.file.closeTab": "Close Tab",
        "command.file.new": "New File",
        "command.file.nextTab": "Next Tab",
        "command.file.open": "Open File",
        "command.file.prevTab": "Previous Tab",
        "command.file.save": "Save",
        "command.file.saveAs": "Save As...",
        "command.palette.open": "Command Palette",
        "command.pane.close": "Close Pane",
        "command.pane.focusNext": "Focus Next Pane",
        "command.pane.focusPrev": "Focus Previous Pane",
        "command.pane.splitDown": "Split Pane Down",
        "command.pane.splitRight": "Split Pane Right",
        "command.placeholder": "Type a command...",
        "command.plugin.clearAll": "Clear All Outputs",
        "command.plugin.runAll": "Run All Plugins",
        "command.plugin.stopAll": "Stop All Plugins",
        "command.search.focus": "Search in Files",
        "command.settings.open": "Open Settings",
        "command.sidebar.engine": "Show Engine",
        "command.sidebar.explorer": "Show Explorer",
        "command.sidebar.files": "Show Open Files",
        "command.sidebar.installedPlugins": "Show Installed Plugins",
        "command.sidebar.plugins": "Show Plugin Instances in Explorer",
        "command.sidebar.sidecars": "Show Sidecars",
        "command.sidebar.toc": "Show Table of Contents",
        "command.view.editor": "Editor Only",
        "command.view.preview": "Preview Only",
        "command.view.split": "Split View",
        "command.view.toggleDarkMode": "Toggle Theme",
        "command.view.toggleLogPanel": "Toggle Log Panel",
        "command.view.toggleRightSidebar": "Toggle Right Sidebar",
        "command.view.toggleSidebar": "Toggle Sidebar",
        "command.view.toggleSyntaxHoverDetail": "Toggle Syntax Hover Detail",
        "command.view.toggleWidgetMode": "Toggle Widget Mode (L0 <-> L2)",
        "command.workspace.close": "Close Workspace",
        "command.workspace.open": "Open Workspace",
        "command.workspace.save": "Save Workspace",
        "common.active": "Active",
        "common.action": "Action",
        "common.actions": "Actions",
        "common.all": "all",
        "common.arguments": "Arguments",
        "common.back": "Back",
        "common.capabilities": "Capabilities",
        "common.cancel": "Cancel",
        "common.close": "Close",
        "common.collapse": "Collapse",
        "common.config": "Config",
        "common.copy": "Copy",
        "common.copied": "Copied!",
        "common.current": "Current",
        "common.default": "Default",
        "common.description": "Description",
        "common.delete": "Delete",
        "common.dependencies": "Dependencies",
        "common.error": "Error",
        "common.expand": "Expand",
        "common.invalidJson": "Invalid JSON",
        "common.loading": "Loading...",
        "common.listSeparator": ", ",
        "common.name": "Name",
        "common.none": "None",
        "common.notFound": "Not found",
        "common.open": "Open",
        "common.optional": "optional",
        "common.paste": "Paste",
        "common.preview": "Preview",
        "common.parameters": "Parameters",
        "common.refresh": "Refresh",
        "common.rename": "Rename",
        "common.required": "required",
        "common.request": "Request",
        "common.response": "Response",
        "common.reset": "Reset",
        "common.retry": "Retry",
        "common.running": "Running",
        "common.run": "Run",
        "common.save": "Save",
        "common.stop": "Stop",
        "common.status": "Status",
        "common.progress": "Progress",
        "common.startTime": "Start time",
        "common.duration": "Duration",
        "common.output": "Output",
        "common.clear": "Clear",
        "common.type": "Type",
        "common.unlimited": "Unlimited",
        "common.unknown": "Unknown",
        "common.untitled": "Untitled",
        "common.yes": "yes",
        "common.no": "no",
        "document.activity.failed": "Failed",
        "document.activity.mcpClient": "MCP client",
        "document.activity.read": "Reading",
        "document.activity.completed": "Completed",
        "document.activity.execute": "Executing",
        "document.activity.externalEditor": "External editor",
        "document.activity.unknownSource": "Unknown source",
        "document.activity.write": "Written",
        "document.path": "Document path",
        "document.unsaved": "Unsaved",
        "annotation.areaComment": "Area comment",
        "annotation.addBlockComment": "Add block comment",
        "annotation.addLocationComment": "Add location comment",
        "annotation.action.resolve": "Resolve",
        "annotation.areaPointCommentPlaceholder": "Add a point or area comment. Type @, #, or /",
        "annotation.blockCommentPlaceholder": "Add a block comment. Type @, #, or /",
        "annotation.cancelLocationComment": "Cancel location comment",
        "annotation.commentCandidates": "Comment candidates",
        "annotation.commentPlaceholder": "Add a comment. Type @, #, or /",
        "annotation.confirmDelete": "Delete annotation \"{name}\"? This will not delete the source Markdown file.",
        "annotation.confirmDeleteGroup": "Delete all annotations in \"{name}\"? This will not delete the source Markdown file.",
        "annotation.confirmDeletePackage": "Delete annotation package \"{name}\"? This will not delete the source Markdown file.",
        "annotation.continueCommentPlaceholder": "Continue the comment. Type @, #, or /",
        "annotation.delete": "Delete Annotation",
        "annotation.deleteComment": "Delete comment",
        "annotation.deleteGroup": "Delete Annotation Group",
        "annotation.deletePackage": "Delete Annotation Package",
        "annotation.edit": "Edit",
        "annotation.editComment": "Edit comment",
        "annotation.elementCommentPlaceholder": "Add an element comment. Type @, #, or /",
        "annotation.elementComment": "Element comment",
        "annotation.goToSource": "Go to Source",
        "annotation.locatePreview": "Locate in Preview",
        "annotation.markResolved": "Mark Resolved",
        "annotation.noMatches": "No matches",
        "annotation.palette.mention": "Mention",
        "annotation.palette.tag": "Tag",
        "annotation.palette.template": "Template",
        "annotation.placementHint": "Drag to select an area, or click an element or point",
        "annotation.pointComment": "Point comment",
        "annotation.rebindPrompt": "Select a new text location to rebind the annotation",
        "annotation.rebindToSelection": "Rebind to Selection",
        "annotation.reopen": "Reopen",
        "annotation.reply": "Reply",
        "annotation.replyComment": "Reply to comment",
        "annotation.replyCommentPlaceholder": "Reply to the comment. Type @, #, or /",
        "annotation.resolveAllInGroup": "Mark Group Resolved",
        "annotation.retryLocate": "Retry Locate",
        "annotation.saveEdit": "Save edit",
        "annotation.source": "Source",
        "annotation.status.commentAdded": "Comment added",
        "annotation.status.commentDeleted": "Comment deleted",
        "annotation.status.commentUpdated": "Comment updated",
        "annotation.status.deleted": "Annotation deleted",
        "annotation.status.groupDeleted": "Annotation group deleted",
        "annotation.status.groupResolved": "Annotation group marked resolved",
        "annotation.status.markedResolved": "Annotation marked resolved",
        "annotation.status.packageDeleted": "Annotation package deleted",
        "annotation.status.packageDeleteFailed": "Failed to delete annotation package: {message}",
        "annotation.status.persistFailed": "Failed to save annotation: {message}",
        "annotation.status.reboundToSelection": "Annotation rebound to current selection",
        "annotation.status.reopened": "Annotation reopened",
        "annotation.status.replyAdded": "Reply added",
        "annotation.status.retryingLocate": "Preview opened. Retrying annotation locate.",
        "annotation.style.comment": "Comment",
        "annotation.style.highlight": "Highlight",
        "annotation.style.underline": "Underline",
        "annotation.viewAreaComment": "View area comment",
        "annotation.viewBlockComment": "View block comment",
        "annotation.viewElementComment": "View element comment",
        "annotation.composer.command.ask": "Insert question template",
        "annotation.composer.command.decision": "Insert decision note",
        "annotation.composer.command.quote": "Insert quote note",
        "annotation.composer.command.resolve": "Insert resolution note",
        "annotation.composer.command.risk": "Insert risk note",
        "annotation.composer.command.source": "Insert source note",
        "annotation.composer.command.todo": "Insert todo template",
        "annotation.composer.definition": "Reference instance",
        "annotation.composer.executedDefinition": "Reference executed instance",
        "annotation.composer.insert.ask": "Question: ",
        "annotation.composer.insert.decision": "Decision: ",
        "annotation.composer.insert.quote": "Quote: ",
        "annotation.composer.insert.resolve": "Resolved: ",
        "annotation.composer.insert.risk": "Risk: ",
        "annotation.composer.insert.source": "Source: ",
        "annotation.composer.insert.todo": "TODO: ",
        "annotation.composer.keywords.ask": "question|ask|confirm",
        "annotation.composer.keywords.decision": "decision|conclusion|plan",
        "annotation.composer.keywords.followUp": "follow up|track",
        "annotation.composer.keywords.question": "question|confirm",
        "annotation.composer.keywords.quote": "quote|original",
        "annotation.composer.keywords.resolve": "resolve|done|complete",
        "annotation.composer.keywords.risk": "risk|blocker",
        "annotation.composer.keywords.source": "source|citation|reference",
        "annotation.composer.keywords.todo": "todo|task",
        "annotation.composer.tag.decision": "Decision",
        "annotation.composer.tag.followUp": "Follow-up",
        "annotation.composer.tag.question": "Question",
        "annotation.composer.tag.risk": "Risk",
        "annotation.composer.tag.source": "Source",
        "annotation.composer.tag.todo": "Todo",
        "dialog.addCurrentFolderToFavorites": "Add current folder to favorites",
        "dialog.allowedRoots": "Allowed Roots",
        "dialog.clearRecents": "Clear recents",
        "dialog.confirm": "Confirm",
        "dialog.dragFoldersHere": "Drag folders here",
        "dialog.dropToAdd": "Drop to add",
        "dialog.enterAllowedPath": "Enter allowed path...",
        "dialog.favorites": "Favorites",
        "dialog.fileName": "File name:",
        "dialog.goToPath": "Go to path...",
        "dialog.noAccessibleRoots": "There are no accessible directory roots. Configure allowed operation directories in Settings first.",
        "dialog.noAllowedRoots": "No allowed roots",
        "dialog.noRecentFolders": "No recent folders",
        "dialog.noRecentWorkspaces": "No recent workspaces",
        "dialog.openFailed": "Open failed: {message}",
        "dialog.openFile": "Open File",
        "dialog.openFolder": "Open Folder",
        "dialog.openingFolder": "Opening folder...",
        "dialog.openingWorkspace": "Opening workspace...",
        "dialog.pathOutsideAllowedRoots": "This path is outside the allowed directory roots",
        "dialog.recents": "Recents",
        "dialog.recentWorkspaces": "Recent Workspaces",
        "dialog.saveFile": "Save File",
        "dialog.selectFolder": "Select Folder",
        "workspace.action.move": "Move",
        "workspace.action.rename": "Rename",
        "workspace.confirmDelete.message": "Delete {label} \"{name}\"? This cannot be undone.",
        "workspace.confirmDelete.title": "Delete {label}",
        "workspace.confirmDeleteReferenced.confirm": "Delete anyway",
        "workspace.confirmDeleteReferenced.footer": "Deleting does not remove reference text automatically. Related documents will show missing-reference diagnostics later.",
        "workspace.confirmDeleteReferenced.message": "Deleting {label} \"{name}\" will break {count} references.",
        "workspace.confirmDeleteReferenced.title": "Delete referenced file",
        "workspace.error.openFolderEngine": "Engine failed to open folder",
        "workspace.error.loadWorkspaceEngine": "Engine failed to load workspace",
        "workspace.error.noFolders": "The workspace file does not contain any folders",
        "workspace.label.file": "file",
        "workspace.label.folder": "folder",
        "workspace.references.actionAndUpdate": "{action} and update references",
        "workspace.references.footerNote": "References that cannot be updated automatically may become invalid after continuing.",
        "workspace.references.impactTitle": "Reference impact",
        "workspace.references.remaining.description": "Open reference diagnostics to continue viewing the full list.",
        "workspace.references.remaining.title": "{count} more references",
        "workspace.references.stillAction": "Still {action}",
        "workspace.references.updateSafe.message": "{action} will update {count} references.",
        "workspace.references.updateTitle": "Update references",
        "workspace.references.updateUnsafe.message": "{action} affects {count} references, and some cannot be updated automatically.",
        "workspace.status.addAssetFileFailed": "Failed to create asset file",
        "workspace.status.addAssetFolderFailed": "Failed to create asset folder",
        "workspace.status.addFolderFailed": "Failed to create folder",
        "workspace.status.assetFileCreated": "Asset file created: {name}",
        "workspace.status.assetFolderCreated": "Asset folder created: {name}",
        "workspace.status.clipboardEmpty": "Clipboard is empty",
        "workspace.status.closeFailed": "Failed to close workspace: {message}",
        "workspace.status.closed": "Workspace closed",
        "workspace.status.copyPathFailed": "Failed to copy path",
        "workspace.status.copyPathSucceeded": "Path copied",
        "workspace.status.copied": "Copied: {name}",
        "workspace.status.deleteFailed": "Failed to delete: {name}",
        "workspace.status.deleted": "Deleted: {name}",
        "workspace.status.fileCreated": "File created: {name}",
        "workspace.status.fileCreateFailed": "Failed to create file",
        "workspace.status.fileExists": "File already exists: {name}",
        "workspace.status.fileNameInvalid": "Invalid file name",
        "workspace.status.folderAdded": "Folder added: {name}",
        "workspace.status.folderAddFailed": "Failed to add folder: {message}",
        "workspace.status.folderExists": "Folder already exists: {name}",
        "workspace.status.folderNameInvalid": "Invalid folder name",
        "workspace.status.folderOpened": "Folder opened: {name}",
        "workspace.status.folderOpenFailed": "Failed to open folder: {message}",
        "workspace.status.folderRemoved": "Folder removed: {name}",
        "workspace.status.folderRemoveFailed": "Failed to remove folder: {message}",
        "workspace.status.folderReadFailed": "Failed to read folder",
        "workspace.status.loadFailed": "Failed to load workspace: {message}",
        "workspace.status.loaded": "Workspace loaded: {name}",
        "workspace.status.moved": "Moved: {name}",
        "workspace.status.movedMany": "Moved {count} items",
        "workspace.status.movedWithReferences": "Moved {count} items and updated {references} references",
        "workspace.status.moveFailed": "Move failed: {message}",
        "workspace.status.movePartial": "Moved {moved}/{total} items; the remaining move failed: {message}",
        "workspace.status.moveDestinationChanged": "The destination changed after confirmation (expected {expected}, actual {actual}); this item was not moved",
        "workspace.status.bundleMoveStateChanged": "The paired data directory changed while moving: {name}",
        "workspace.status.movedReferenceUpdateFailed": "Moved {count} items, but failed to update references: {message}",
        "workspace.status.pasted": "Pasted: {name}",
        "workspace.status.pasteFailed": "Paste failed",
        "workspace.status.renameFailed": "Rename failed",
        "workspace.status.renamed": "Renamed to: {name}",
        "workspace.status.renamedWithReferences": "Renamed to: {name}, and updated {references} references",
        "workspace.status.saveFailed": "Failed to save workspace: {message}",
        "workspace.status.saved": "Workspace saved: {name}",
        "workspace.status.starFailed": "Failed to star: {message}",
        "workspace.status.targetBundleExists": "Target bundle already exists: {name}",
        "workspace.status.targetExists": "Target already exists: {name}",
        "tabs.confirm.externalChange.message": "\"{title}\" was modified externally. Reload it? Unsaved changes will be lost.",
        "tabs.confirm.externalChange.title": "File changed externally",
        "tabs.status.autoReloadFailed": "Failed to reload file",
        "tabs.status.autoReloaded": "Automatically reloaded: {title}",
        "tabs.status.doctorNoSave": "Doctor panel does not need to be saved",
        "tabs.status.doctorNoSaveAs": "Doctor panel does not need Save As",
        "tabs.status.fileSaved": "Saved: {title}",
        "tabs.status.icloudNotDownloaded": "This file is stored in iCloud and has not been downloaded. Download it in Finder and try again.",
        "tabs.status.noWorkspaceLoaded": "No .mdspace workspace is currently loaded",
        "tabs.status.opened": "Opened: {title}",
        "tabs.status.openFailed": "Failed to open file: {message}",
        "tabs.status.openedDoctor": "Doctor opened: {name}",
        "tabs.status.openedWorkspaceConfig": "Workspace config opened: {title}",
        "tabs.status.saveAsFailed": "Save As failed",
        "tabs.status.savedAs": "Saved as: {title}",
        "tabs.status.saveFailed": "Save failed",
        "tabs.status.workspaceConfigSaved": "Workspace config saved",
        "menubar.backgroundDocument": "Background document {id}",
        "menubar.contentRunning": "Content running",
        "menubar.currentDocument": "Current document",
        "menubar.currentUnit": "Current: {id}",
        "menubar.documentPublish": "Document publish",
        "menubar.folder": "Folder",
        "menubar.forRunning": "For running",
        "menubar.importRunning": "Import running",
        "menubar.moveToNewWindow": "Move to new window",
        "menubar.pinToMenuBar": "Pin to menu bar",
        "menubar.pinned": "Pinned to menu bar: {title}",
        "menubar.pinnedDirty": "Pinned to menu bar. Preview reads the disk version, so unsaved changes will not appear.",
        "menubar.publishRunning": "Publishing",
        "menubar.runAllRunning": "Batch running",
        "menubar.running": "Running",
        "menubar.sitePublish": "Site publish",
        "menubar.unpinFromMenuBar": "Unpin from menu bar",
        "menubar.unpinned": "Unpinned from menu bar: {title}",
        "menubar.useRunning": "Use running",
        "pinned.backToDocumentList": "Back to document list",
        "pinned.cancelTask": "Cancel task",
        "pinned.emptyDocuments": "No pinned documents",
        "pinned.fixedDocument": "Pinned document",
        "pinned.fixedDocuments": "Pinned Documents",
        "pinned.hiddenDocuments": "{count} more pinned documents",
        "pinned.hiddenSidecars": "{count} more Sidecars running",
        "pinned.hiddenTasks": "{count} more tasks running",
        "pinned.hiddenWorkspaces": "{count} more workspaces",
        "pinned.loadingDocument": "Loading document...",
        "pinned.noRunningSidecars": "No running Sidecars",
        "pinned.openInEditor": "Open in Editor",
        "pinned.quickAccess": "Quick Access",
        "pinned.readDocumentFailed": "Failed to read document: {message}",
        "pinned.recentWorkspaces": "Recent Workspaces",
        "pinned.refreshStatus": "Refresh Status",
        "pinned.runtime": "Runtime",
        "pinned.runningSidecars": "Running Sidecars",
        "pinned.sidecarsRunning": "{count} running",
        "pinned.runningTasks": "Running",
        "pinned.showMainWindow": "Show Main Window",
        "pinned.startMcp": "Start MCP",
        "pinned.stopMcp": "Stop MCP",
        "pinned.unpin": "Unpin",
        "detached.moveBackToMain": "Move back to main window",
        "instance.availablePlugins": "Available plugins",
        "instance.detailTitle": "Instance Detail",
        "instance.notFound.detail": "It may have been removed from the document.",
        "instance.notFound.title": "Instance \"{id}\" not found",
        "instance.pluginMissing": "Plugin \"{name}\" is not installed. {availableLabel}: {available}",
        "instance.primaryAction": "Primary",
        "instance.ref.notExecuted": "Not run",
        "instance.ref.notFound": "Not found",
        "instance.ref.pathInvalid": "Path missing",
        "instance.section.executionInfo": "Execution Info",
        "instance.section.useConfig": "Use Config",
        "instance.status.error": "Failed",
        "instance.status.idle": "Idle",
        "instance.status.running": "Running",
        "instance.status.success": "Completed",
        "instance.templateNotExecutable": "Template units do not run directly",
        "definition.contentInstance": "Content instance",
        "definition.dragMoveConfig": "Drag to move config panel",
        "definition.moving": "Moving",
        "definition.noConfig": "This content instance has no configurable fields",
        "definition.noOutputRun": "No output yet. Click Run to execute.",
        "definition.notInstalled": "Not installed",
        "definition.resizeConfig": "Resize config panel",
        "definition.template": "Template",
        "definition.templateInstance": "Template instance",
        "definition.typeTitle": "Type: {type}",
        "template.defaultLabel": "Default: {value}",
        "template.inputFallback": "Template input",
        "template.missingRequired": "Required parameter is empty",
        "template.missingRequiredCount": "{count} required missing",
        "template.params": "Template Parameters",
        "template.unfilledCount": "{count} unfilled",
        "template.valuePlaceholder": "{name} value...",
        "templateInputs.add": "Add",
        "templateInputs.closeEditor": "Close inputs editor",
        "templateInputs.commaSeparated": "comma-separated",
        "templateInputs.defaultValue": "Default value",
        "templateInputs.description": "Description",
        "templateInputs.displayName": "Display name",
        "templateInputs.dragMove": "Drag to move config panel",
        "templateInputs.enum": "Enum",
        "templateInputs.jsonOrReference": "JSON or reference",
        "templateInputs.name": "Name",
        "templateInputs.noDefaultValue": "No default value",
        "templateInputs.noneDeclared": "No inputs declared",
        "templateInputs.syncUndeclared": "{count} used input(s) are not declared. Click to add them.",
        "templateInputs.type": "Type",
        "templateInputs.unnamedInput": "Unnamed input",
        "editor.bookmark.addAtLine": "Add bookmark at line {line}",
        "editor.bookmark.addWithLabel": "Add bookmark with label...",
        "editor.bookmark.delete": "Delete bookmark",
        "editor.bookmark.labelPrompt": "Bookmark label",
        "editor.bookmark.rename": "Rename bookmark...",
        "editor.codeAction.preferred": "Preferred",
        "editor.circularFailedHint": "Check your Markdown file and make sure plugins do not reference each other recursively.",
        "editor.circularFailedTitle": "Execution failed.",
        "editor.renameTitle": "Rename {id}",
        "editor.snapshot.error": "Snapshot failed: {message}",
        "editor.snapshot.failed": "File snapshot failed",
        "editor.snapshot.inProgress": "Taking file snapshot...",
        "editor.snapshot.succeeded": "File snapshot saved",
        "smartIntake.action.apply": "Apply",
        "smartIntake.error.assetItemNotFound": "Smart Intake asset item was not found",
        "smartIntake.error.definitionNotFound": "Definition not found: {id}",
        "smartIntake.error.filePayloadUnavailable": "Smart Intake file payload is unavailable",
        "smartIntake.error.saveAssetFailed": "Failed to save {name}",
        "smartIntake.error.saveBeforeImport": "Document must be saved before importing files",
        "smartIntake.error.stageAssetFailed": "Failed to stage {name}",
        "smartIntake.offer.insertAssets": "Insert as Markdown assets",
        "smartIntake.offer.insertAssets.description": "Save files into document assets and insert Markdown references.",
        "smartIntake.offer.insertMarkdown": "Insert as Markdown",
        "smartIntake.offer.insertMarkdown.description": "Insert normalized Markdown at the cursor.",
        "smartIntake.offer.insertTable": "Insert as Markdown table",
        "smartIntake.source.builtin": "Built-in",
        "smartIntake.status.applied": "Smart Intake applied",
        "smartIntake.status.failed": "Smart Intake failed: {message}",
        "smartIntake.status.inlineImageFallback": "Inserted image inline. Save the document to import future files into assets.",
        "smartIntake.status.saveBeforeImport": "Save the document before importing files.",
        "smartIntake.title": "Smart Intake",
        "doctor.assetsEscapesDir": "assets reference path should not leave the document assets directory: {target}",
        "doctor.buffer": "buffer",
        "doctor.dependencyGraph": "Dependency Graph",
        "doctor.close": "Close Doctor",
        "doctor.closeDependencyDetail": "Close dependency detail",
        "doctor.closeTimelineDetail": "Close resource timeline detail",
        "doctor.dependencyGraphTruncated.detail": "Analyzed at most {documents} imported documents and {nodes} resource nodes.",
        "doctor.dependencyGraphTruncated.title": "Dependency graph is large; some nodes were truncated",
        "doctor.errorCount": "{count} errors",
        "doctor.hiddenCount": "Hidden {count}",
        "doctor.largeDocument.detail": "Large documents increase parsing, preview, and session sync costs.",
        "doctor.largeDocument.title": "Document file is large: {size}",
        "doctor.largeResource": "Resource file is large: {name} ({size})",
        "doctor.missingAsset": "assets referenced file does not exist: {target}",
        "doctor.missingDocumentPath": "Missing document path",
        "doctor.missingImport": "import source file does not exist: {source}",
        "doctor.missingRef": "$ref target was not found in the current document: {id}",
        "doctor.missingRender": "render target was not found in the current document: {id}",
        "doctor.missingUse": "use source target was not found in the current document: {source}",
        "doctor.noDirectRelations": "No direct relations",
        "doctor.noIssues": "No clear issues found",
        "doctor.noResourceTimeline": "No resource timeline",
        "doctor.noDependencies": "No dependencies",
        "doctor.normal": "Normal",
        "doctor.openDocument": "Open document",
        "doctor.outputError": "{kind} \"{id}\" output error",
        "doctor.problemCount": "{count} issues",
        "doctor.refresh": "Refresh",
        "doctor.resourceScanTruncated.detail": "Only the first {count} entries were scanned.",
        "doctor.resourceScanTruncated.title": "{label} has many files; scan was truncated",
        "doctor.resourcesSize": "Resources {size}",
        "doctor.resourcesNone": "No resource packages",
        "doctor.scanning": "Scanning...",
        "doctor.severity.error": "Error",
        "doctor.severity.info": "Info",
        "doctor.severity.warning": "Warning",
        "doctor.showDetails": "View details",
        "doctor.toggleCollapse": "Collapse children",
        "doctor.toggleExpand": "Expand children",
        "doctor.warningCount": "{count} warnings",
        "doctor.documentSummary": "Document {size} / {lines} lines",
        "doctor.childCount": "{count} children",
        "doctor.inspector": "Doctor inspector",
        "doctor.issues": "Issues",
        "doctor.resourceTimeline": "Resource Timeline",
        "doctor.title": "Doctor",
        "documentRenderer.noContent": "No content",
        "installedPlugins.empty": "No plugins installed",
        "installedPlugins.noMatching": "No matching plugins",
        "installedPlugins.searchPlaceholder": "Search plugins...",
        "installedPlugins.title": "Installed Plugins",
        "sidebar.close": "Close sidebar",
        "sidebar.clickConfigButton": "Click a config button in the editor",
        "sidebar.configure": "Configure",
        "sidebar.configureUnit": "Configure {id}",
        "sidebar.cancelSelection": "Clear selection",
        "sidebar.createdLocalOverride": "Created local override: {id}",
        "sidebar.createLocalUseOverride": "Create a local use override in the current document",
        "sidebar.discardChanges": "Discard changes",
        "sidebar.importedFrom": "Imported from",
        "sidebar.localOverride": "Local override",
        "sidebar.pinnedUnit.dock": "Dock panel",
        "sidebar.pinnedUnit.float": "Float panel",
        "sidebar.pinnedUnit.loading": "Loading pinned unit...",
        "sidebar.pinnedUnit.openSource": "Open source document",
        "sidebar.pinnedUnit.remove": "Remove from sidebar",
        "sidebar.pinnedUnit.unavailable": "Pinned unit unavailable",
        "sidebar.requiresImportEditTarget": "Choose the source file or local override before editing imported unit config",
        "sidebar.resize": "Resize sidebar",
        "sidebar.selectInstance": "Select an instance",
        "sidebar.sourceFile": "Source file",
        "sidebar.title": "Sidebar",
        "sidebar.unpin": "Unpin",
        "sidebar.unpinUnit": "Unpin {id}",
        "sidebar.writeBackFailed": "Failed to write back source file: {message}",
        "sidebar.writeBackSource": "Write back to imported source file",
        "sidebar.wroteBackSource": "Wrote back source file: {id}",
        "connector.action.cancel": "Cancel",
        "connector.action.connect": "Connect",
        "connector.action.disconnect": "Disconnect",
        "connector.action.refreshStatus": "Refresh connection status",
        "connector.action.probe": "Detect Engine",
        "connector.detected": "Engine detected",
        "connector.disconnected": "Disconnected",
        "connector.gatewayHelp": "Run {command} to start Gateway on the default port 3721",
        "connector.localHelp": "Run {command} to start Engine on the default port 3721",
        "connector.mode.builtin": "Built-in",
        "connector.mode.builtinConnected": "Built-in Engine",
        "connector.mode.cloud": "Cloud",
        "connector.mode.cloudConnected": "Cloud Engine",
        "connector.mode.cloudHelp": "Connect to a cloud Engine service.",
        "connector.mode.devConnected": "Development Mode",
        "connector.mode.devHelp": "Engine starts automatically from the workspace. No extra configuration is required.",
        "connector.mode.gatewayConnected": "Gateway Connection",
        "connector.mode.local": "Local",
        "connector.mode.localConnected": "Local Engine",
        "connector.mode.none": "Disconnected",
        "connector.notConnected": "Not connected",
        "connector.notReady": "Engine is not ready",
        "connector.status.connecting": "Connecting...",
        "connector.status.ready": "Ready",
        "connector.status.starting": "Starting",
        "connector.title": "Engine Connection",
        "connector.editor.builtin.dir": "Engine Directory Override",
        "connector.editor.builtin.dirHelp": "The bundled Engine is used by default. Optionally choose a Magic MD CLI directory containing {engine}, {plugins}, and {sidecars}.",
        "connector.editor.builtin.source": "Engine Runtime",
        "connector.editor.builtin.bundled": "Bundled (default)",
        "connector.editor.builtin.custom": "Custom directory",
        "connector.editor.builtin.customDirRequired": "Choose a custom Engine runtime directory before connecting.",
        "connector.editor.builtin.sourceReconnectHint": "Runtime changes apply the next time Built-in Engine connects.",
        "connector.editor.builtin.pickDir": "Choose directory",
        "connector.editor.builtin.dialogTitle": "Choose Engine directory (CLI installation directory)",
        "connector.editor.builtin.checkExisting": "Checking existing Engine...",
        "connector.editor.builtin.missingDir": "The bundled Engine could not be resolved",
        "connector.editor.builtin.notReady": "Engine started but is not ready yet",
        "connector.editor.builtin.startFailed": "Engine failed to start",
        "connector.editor.builtin.startingFromDir": "Starting Engine from {dir}...",
        "connector.editor.builtin.startTimeout": "Engine start timed out (30s). Check that the directory path is correct.",
        "connector.editor.builtin.stoppingExisting": "Stopping existing Engine (development mode)...",
        "connector.editor.builtin.stopTimeout": "Stop timed out",
        "connector.editor.dev.restarting": "Restarting development Engine...",
        "connector.editor.dev.timeout": "Development Engine start timed out (15s)",
        "connector.editor.dev.wait": "Waiting for development Engine to start...",
        "connector.editor.dev.waitWithAttempt": "Waiting for development Engine to start... ({current}/{total})",
        "connector.editor.disconnectedHint": "Choose Built-in to use the bundled runtime by default, select a custom runtime directory, or connect through Gateway.",
        "connector.editor.gateway.title": "Web Access (LAN)",
        "connector.editor.gateway.lanHelp": "Expose this same Engine on all LAN interfaces (0.0.0.0) without authentication.",
        "connector.editor.gateway.unsupported": "This Engine runtime does not support embedded Web access.",
        "connector.editor.gateway.copied": "LAN Gateway address copied.",
        "connector.editor.gateway.openWeb": "Open Web",
        "connector.editor.gateway.copyLanAddress": "Copy LAN address",
        "connector.editor.gateway.stop": "Stop Web access",
        "connector.editor.gateway.start": "Start Web access",
        "connector.editor.gateway.starting": "Starting...",
        "connector.web.disconnectedHint": "Run {command} to start a local Engine, or connect to a cloud Engine.",
        "continuation.checkReference": "Check whether the referenced ID is correct.",
        "continuation.depthDetail": "Current depth {depth}; maximum allowed {max}.",
        "continuation.depthLimit": "Nesting depth exceeded",
        "continuation.missingTarget": "{kind} \"{id}\" not found",
        "continuation.recursion": "Recursive mount detected",
        "engine.mcp.clientsConnected": "{count} clients connected",
        "engine.refresh": "Refresh",
        "engine.extensions.empty": "No extensions installed yet",
        "engine.sections.extensions": "Extensions",
        "engine.sections.mcpServer": "MCP Server",
        "engine.sections.plugins": "Plugins",
        "engine.sections.sessions": "Sessions",
        "engine.sections.sidecars": "Sidecars",
        "engine.sessions.close": "Close session",
        "engine.sessions.closeAll": "Close all sessions",
        "engine.sessions.empty": "No active sessions",
        "engine.sessions.openFile": "Open file",
        "engine.status.connected": "Connected",
        "engine.status.notRunning": "Not running",
        "engine.status.offline": "Offline",
        "engine.status.online": "Online",
        "engine.status.starting": "Starting",
        "engine.status.startingShort": "Starting",
        "engine.plugins.actionCount": "{count} actions",
        "extensionDetail.activationEvents": "Activation Events",
        "extensionDetail.backends": "Backends",
        "extensionDetail.contributions": "Contributions",
        "extensionDetail.contributions.commands": "Commands",
        "extensionDetail.contributions.contextMenus": "Context Menus",
        "extensionDetail.contributions.exports": "Exports",
        "extensionDetail.contributions.runtimeEvents": "Runtime Events",
        "extensionDetail.contributions.runtimeMethods": "Runtime Methods",
        "extensionDetail.contributions.settings": "Settings Surface",
        "extensionDetail.contributions.statusBar": "Status Bar",
        "extensionDetail.contributions.unitActions": "Unit Actions",
        "extensionDetail.detailTitle": "Extension Detail",
        "extensionDetail.features": "Features",
        "extensionDetail.homepage": "Homepage",
        "extensionDetail.manifest": "Manifest",
        "extensionDetail.notFound": "Extension \"{id}\" not found",
        "extensionDetail.openPanel": "Open Panel",
        "extensionDetail.overview": "Overview",
        "extensionDetail.permissions": "Permissions",
        "extensionDetail.runtime": "Runtime",
        "extensionDetail.runtime.status": "Status",
        "extensionDetail.runtime.type": "Runtime Type",
        "extensionDetail.settings": "Settings",
        "extensionDetail.settings.customPanel": "Custom Panel",
        "extensionDetail.settings.fields": "Schema Fields",
        "extensionDetail.sidebarPanels": "Sidebar Panels",
        "extensionDetail.source.cssUrl": "CSS URL",
        "extensionDetail.source.invokeUrl": "Invoke URL",
        "extensionDetail.source.localPath": "Local Path",
        "extensionDetail.source.manifestPath": "Manifest Path",
        "extensionDetail.source.manifestUrl": "Manifest URL",
        "extensionDetail.source.type": "Type",
        "extensionDetail.source.uiBundlePath": "UI Bundle Path",
        "extensionDetail.source.uiBundleUrl": "UI Bundle URL",
        "extensionDetail.source.version": "Version",
        "extensionDetail.sourceInfo": "Source Info",
        "extensionDetail.status.active": "Active",
        "extensionDetail.status.inactive": "Inactive",
        "extensionPanel.cloudSource": "Cloud extension",
        "extensionPanel.filter.all": "All extensions",
        "extensionPanel.filter.cloud": "Cloud extensions",
        "extensionPanel.filter.local": "Local extensions",
        "extensionPanel.hasSidebarPanel": "Has sidebar panel",
        "extensionPanel.loadingWindow": "Loading extension panel...",
        "extensionPanel.missingWindowPanel": "This extension panel is not available in this window.",
        "extensionPanel.noMatching": "No matching extensions",
        "extensionPanel.searchPlaceholder": "Search extensions",
        "explorer.assets.copyMarkdown": "Copy Markdown Link",
        "explorer.assets.copyRef": "Copy Assets Reference",
        "explorer.assets.copyRefPrefix": "Copy Assets Reference Prefix",
        "explorer.assets.imported": "Imported assets file: {name}",
        "explorer.assets.importFailed": "Failed to import assets file: {message}",
        "explorer.assets.importFile": "Import File to Assets...",
        "explorer.assets.createFileFailed": "Failed to create assets file: {message}",
        "explorer.assets.createFolderFailed": "Failed to create assets folder: {message}",
        "explorer.assets.fileCreated": "Created assets file: {name}",
        "explorer.assets.folderCreated": "Created assets folder: {name}",
        "explorer.assets.invalidFileName": "Invalid file name",
        "explorer.assets.invalidFolderName": "Invalid folder name",
        "explorer.assets.newFile": "New Assets File",
        "explorer.assets.newFolder": "New Assets Folder",
        "explorer.assets.paste": "Paste to Assets",
        "explorer.bookmarks.delete": "Delete Bookmark",
        "explorer.bookmarks.line": "Line {line}",
        "explorer.bookmarks.lineTitle": "Line {line}",
        "explorer.bookmarks.renameLabel": "Rename Label",
        "explorer.closeFailed": "Close failed: {message}",
        "explorer.configs.confirmDeleteAll": "Delete all file-based config for this document? This will not delete the source Markdown file.",
        "explorer.configs.confirmDeleteEditor": "Delete editor file-based config for \"{instanceId}\"? This will not delete the source Markdown file.",
        "explorer.configs.confirmDeleteFile": "Delete \"{name}\"? This will not change plugin config in the source Markdown.",
        "explorer.configs.confirmDeleteInstance": "Delete file-based config for \"{instanceId}\"? This only deletes that instance directory and does not delete other configs.",
        "explorer.configs.confirmDeleteRender": "Delete render temporary config for \"{instanceId}\"? This will not delete the source Markdown file.",
        "explorer.configs.deleteAll": "Delete All Configs",
        "explorer.configs.deleteEditor": "Delete Editor Config Directory",
        "explorer.configs.deleteFailed": "Failed to delete Configs: {message}",
        "explorer.configs.deleteFile": "Delete Configs File",
        "explorer.configs.deleteInstance": "Delete \"{instanceId}\" Config Directory",
        "explorer.configs.deleteRender": "Delete Render Config Directory",
        "explorer.configs.deleted": "Configs file deleted",
        "explorer.createFailed": "Create failed: {message}",
        "explorer.deleteFailed": "Delete failed: {message}",
        "explorer.deleted": "Deleted: {name}",
        "explorer.emptyFolder": "Empty folder",
        "explorer.selection.summary": "{count} selected · drag any selected item to move together (⌘/Ctrl-click, Shift-click for a range)",
        "explorer.fileExists": "File already exists: {name}",
        "explorer.files": "Files",
        "explorer.folderExists": "Folder already exists: {name}",
        "explorer.history.createFullSnapshot": "Create Snapshot (Whole File)",
        "explorer.history.createSnapshot": "Create Snapshot",
        "explorer.history.deleteSnapshot": "Delete Snapshot",
        "explorer.history.deletingSnapshot": "Deleting...",
        "explorer.history.restoreFull": "Full Restore...",
        "explorer.history.snapshotCreated": "Whole-file snapshot created",
        "explorer.history.snapshotDeleted": "Snapshot deleted",
        "explorer.history.snapshotDeleteFailed": "Failed to delete snapshot",
        "explorer.history.snapshotFailed": "Failed to create whole-file snapshot",
        "explorer.history.noSnapshots": "No snapshots",
        "explorer.history.snapshots": "Snapshots",
        "explorer.history.snapshotTaking": "Creating whole-file snapshot...",
        "explorer.history.wholeFile": "Whole file",
        "explorer.moreActionsHint": "Right-click for more actions",
        "explorer.newFile": "New File",
        "explorer.newFolder": "New Folder",
        "explorer.noFolderOpen": "No folder open",
        "explorer.openAnotherFolder": "Open Another Folder",
        "explorer.operationFailed": "Operation failed: {message}",
        "explorer.outputs.confirmDelete": "Delete output artifacts directory \"{name}\"? This will not delete the source Markdown file.",
        "explorer.outputs.delete": "Delete Outputs Artifacts",
        "explorer.outputs.deleted": "Outputs artifacts deleted",
        "explorer.outputs.deleteFailed": "Failed to delete Outputs artifacts: {message}",
        "explorer.preview.openInBrowser": "Preview in Browser",
        "explorer.preview.running": "Previewing",
        "explorer.preview.serverReady": "Preview server is running",
        "explorer.preview.starting": "Starting",
        "explorer.preview.switchServerHere": "Switch preview server here",
        "explorer.publish.cancelled": "Cancelled",
        "explorer.publish.completed": "Published",
        "explorer.publish.confirmDeleteFolderOutput": "Delete the publish output directory for \"{name}\"? This will not delete the source folder.",
        "explorer.publish.confirmDeleteDocumentOutput": "Delete the publish output directory for \"{name}\"? This will not delete the source Markdown file.",
        "explorer.publish.deleteOutput": "Delete Publish Output",
        "explorer.publish.failed": "Publish failed",
        "explorer.publish.outputDeleted": "Publish output deleted",
        "explorer.publish.outputDeleteFailed": "Failed to delete publish output: {message}",
        "explorer.publish.revealOutput": "Reveal Output in Folder",
        "explorer.publish.running": "Publishing",
        "explorer.publish.runningPages": "Publishing {processed}/{total}",
        "explorer.publish.runningPercent": "Publishing {percent}%",
        "explorer.renameFailed": "Rename failed: {message}",
        "explorer.refreshFailed": "Refresh failed: {message}",
        "explorer.refreshed": "Refreshed: {name}",
        "explorer.revealInFolder": "Reveal in Folder",
        "explorer.saveFailed": "Save failed: {message}",
        "explorer.starred": "Starred",
        "explorer.trace.copyJson": "Copy Trace JSON",
        "explorer.trace.delete": "Delete Trace",
        "explorer.trace.deleted": "Trace deleted: {name}",
        "explorer.trace.deleteConfirm": "Delete trace {name}?",
        "explorer.trace.invalidFile": "Trace file is invalid: {traceId}",
        "explorer.trace.loadFailed": "Trace load failed: {message}",
        "explorer.trace.notFound": "Trace not found: {traceId}",
        "explorer.trace.save": "Save Trace",
        "explorer.trace.saved": "Trace saved: {name}",
        "explorer.trace.saveFailed": "Trace save failed: {message}",
        "explorer.trace.showInTrace": "Show in Trace",
        "explorer.workspace.addFolder": "Add Folder to Workspace",
        "explorer.workspace.addFolderFailed": "Failed to add folder",
        "explorer.workspace.close": "Close Workspace",
        "explorer.workspace.closed": "Workspace closed",
        "explorer.workspace.folderAdded": "Folder added to workspace",
        "explorer.workspace.folderRemoved": "Folder removed from workspace",
        "explorer.workspace.opened": "Workspace opened",
        "explorer.workspace.openFile": "Open Workspace File",
        "explorer.workspace.removeFolder": "Remove from Workspace",
        "explorer.workspace.save": "Save Workspace",
        "explorer.workspace.saved": "Workspace saved",
        "explorer.workspace.title": "Workspace",
        "file.openFolder": "Open Folder",
        "history.delete.deleted": "Snapshot deleted",
        "history.delete.failed": "Failed to delete snapshot",
        "history.delete.failedWithMessage": "Failed to delete snapshot: {message}",
        "history.delete.inProgress": "Deleting snapshot...",
        "history.noDiff": "No differences",
        "history.relative.daysAgo": "{count} days ago",
        "history.relative.hoursAgo": "{count} hours ago",
        "history.relative.minutesAgo": "{count} minutes ago",
        "history.relative.secondsAgo": "{count} seconds ago",
        "history.restore.action": "Restore",
        "history.restore.failed": "Restore failed",
        "history.restore.inProgress": "Restoring snapshot...",
        "history.restore.restoredTo": "Restored to {time}",
        "history.restore.restoring": "Restoring...",
        "history.restore.snapshotFailed": "Failed to restore snapshot",
        "history.restore.snapshotFailedWithMessage": "Failed to restore snapshot: {message}",
        "history.restore.snapshotRestored": "Snapshot restored",
        "history.snapshot": "Snapshot",
        "history.snapshotWithTime": "Snapshot - {time}",
        "history.tab.content": "Content",
        "history.tab.diff": "Diff",
        "history.undo.action": "Undo",
        "history.undo.failedWithMessage": "Undo failed: {message}",
        "history.undo.inProgress": "Undoing restore...",
        "history.undo.success": "Restore undone",
        "menu.addAssetsPackage": "Add Assets Package",
        "menu.addToFavorites": "Add to Favorites",
        "menu.closeAll": "Close All",
        "menu.closeOthers": "Close Others",
        "menu.closeToRight": "Close to Right",
        "menu.copyFailed": "Copy failed",
        "menu.copyFileName": "Copy File Name",
        "menu.copyPath": "Copy Path",
        "menu.copyRelativePath": "Copy Relative Path",
        "menu.copiedFileName": "File name copied",
        "menu.copiedRelativePath": "Relative path copied",
        "menu.createAssetsPackageFailed": "Failed to create assets package: {message}",
        "menu.externalOpenFailed": "{label} failed: {message}",
        "menu.externalOpenUnsupported": "External opening is not supported on this platform",
        "menu.locateInExplorer": "Reveal in Explorer",
        "menu.openFile": "Open File",
        "menu.openToSide": "Open to Side",
        "menu.openWith": "Open With",
        "menu.previewPublish": "Preview Publish",
        "menu.publishDocument": "Publish Document...",
        "menu.publishFolder": "Publish Folder...",
        "menu.removeFromFavorites": "Remove from Favorites",
        "menu.switchToFile": "Switch to File",
        "menu.assetsPackageReady": "Assets package is ready",
        "openFiles.backgroundRunning": "Running in background",
        "openFiles.circularImport": "Circular import: {path}",
        "openFiles.titleWithCount": "Open Files ({count})",
        "recentFiles.titleWithCount": "Recent Files ({count})",
        "search.cancel": "Cancel search",
        "search.caseSensitive": "Case sensitive",
        "search.empty": "Enter a query to search",
        "search.excludePlaceholder": "Exclude glob",
        "search.fileFilter": "File filter",
        "search.includePlaceholder": "Include glob",
        "search.placeholder": "Search",
        "search.regex": "Regular expression",
        "search.scope.session": "Current session",
        "search.scope.workspace": "Workspace",
        "search.status.results": "{matches} matches in {files} files",
        "search.status.truncated": "Results truncated",
        "search.wholeWord": "Whole word",
        "settings.appearance.colorTheme.description": "Default Color Theme for the current project; can be overridden at user or workspace level.",
        "settings.appearance.colorTheme.title": "Color Theme",
        "settings.appearance.fileIconTheme.description": "Default File Icon Theme for the current project; can be overridden at user or workspace level.",
        "settings.appearance.fileIconTheme.title": "File Icon Theme",
        "settings.appearance.productIconTheme.description": "Default Product Icon Theme for the current project; can be overridden at user or workspace level.",
        "settings.appearance.productIconTheme.title": "Product Icon Theme",
        "settings.apply.applying": "Applying...",
        "settings.apply.success": "Apply has been triggered.",
        "settings.apply.unavailable": "This setting cannot be applied immediately.",
        "settings.autoSave.description": "Automatically save edits back to the current file.",
        "settings.autoSave.title": "Auto Save",
        "settings.boolean.disabled": "Off",
        "settings.boolean.enabled": "Enabled",
        "settings.boolean.off": "Off",
        "settings.boolean.on": "On",
        "settings.boolean.stopped": "Disabled",
        "settings.cancel": "Cancel",
        "settings.clear": "Clear",
        "settings.clearTarget": "Clear {target}",
        "settings.close": "Close Settings",
        "settings.codeMirror.hoverDetail.description": "Controls whether CodeMirror syntax hover shows detailed information; can be overridden per workspace.",
        "settings.codeMirror.hoverDetail.title": "Hover Details",
        "settings.codeMirror.widgetMode.description": "Switches between structured widgets and raw syntax text; can be overridden per workspace.",
        "settings.codeMirror.widgetMode.title": "Syntax Display Mode",
        "settings.configItemCount": "{count} settings",
        "settings.defaultPreviewWidth.description": "Preview width used for new panes or panes without an explicit setting.",
        "settings.defaultPreviewWidth.title": "Default Preview Width",
        "settings.defaultViewMode.description": "Controls whether newly opened editor areas or panes show editor, split, or preview mode.",
        "settings.defaultViewMode.title": "Default View Mode",
        "settings.engine.allowedOperationDirs.description": "Restricts the directory roots the Engine may read, write, browse, and use for workspace operations. Empty uses the safe default roots.",
        "settings.engine.allowedOperationDirs.title": "Allowed Operation Directories",
        "settings.engine.allowedSidecars.description": "Empty means unrestricted; an array acts as an allowlist.",
        "settings.engine.allowedSidecars.title": "Allowed Sidecars",
        "settings.engine.docsDir.description": "Default document directory for the Engine.",
        "settings.engine.docsDir.title": "Documents Directory",
        "settings.engine.logLevel.description": "Minimum diagnostic level emitted by the Engine. CLI and environment overrides still take precedence.",
        "settings.engine.logLevel.title": "Engine Log Level",
        "settings.engine.mcp.defaultPort.description": "Default listen port for the MCP HTTP Server. When set, this port is preferred; if occupied, the server falls back to a random port. Only applies outside Gateway mode.",
        "settings.engine.mcp.defaultPort.title": "MCP Default Port",
        "settings.engine.pluginDirs.description": "Plugin directory list scanned when the Engine starts.",
        "settings.engine.pluginDirs.title": "Plugin Directories",
        "settings.engine.startupTimeoutMs.description": "Timeout threshold, in milliseconds, used by hosts when starting the Engine.",
        "settings.engine.startupTimeoutMs.title": "Startup Timeout",
        "settings.gateway.allowedOrigins.description": "Origins allowed by Gateway CORS.",
        "settings.gateway.allowedOrigins.title": "Allowed Origins",
        "settings.gateway.host.description": "Host address bound by the Gateway HTTP service.",
        "settings.gateway.host.title": "Listen Address",
        "settings.gateway.logLevel.description": "Minimum diagnostic level emitted by the Gateway and Engine bridge. CLI and environment overrides still take precedence.",
        "settings.gateway.logLevel.title": "Gateway Log Level",
        "settings.gateway.port.description": "Listen port for the Gateway HTTP service.",
        "settings.gateway.port.title": "Listen Port",
        "settings.gateway.token.description": "Gateway Bearer Token. Sensitive values are masked by default.",
        "settings.gateway.token.title": "Access Token",
        "settings.detailMode.form": "Settings",
        "settings.detailMode.info": "Info",
        "settings.diagnostics.errors": "{count} errors",
        "settings.diagnostics.removeFromTarget": "Remove from {target} config",
        "settings.diagnostics.sidecarsFsAlwaysEnabled": "The built-in fs Sidecar is always enabled, so sidecars.fs.enabled in config is ignored.",
        "settings.diagnostics.title": "Configuration Diagnostics",
        "settings.diagnostics.warnings": "{count} warnings",
        "settings.directory.add": "Add Folder",
        "settings.directory.emptyHelp": "One folder per line. Saving an empty list keeps it empty; use Clear to restore the default safe roots.",
        "settings.directory.lineHelp": "One folder per line. You can paste multiple paths at once.",
        "settings.directory.pick": "Choose Folder",
        "settings.dynamic.pluginDefaults.description": "Default parameters merged before document instance config; Remote Host can override Workspace.",
        "settings.dynamic.pluginDefaults.title": "{displayName} Default Instance Config",
        "settings.dynamic.pluginEnabled.description": "Controls whether plugin {displayName} is allowed to execute; Remote Host can override Workspace.",
        "settings.dynamic.pluginEnabled.title": "{displayName} Enabled",
        "settings.dynamic.pluginSettings.description": "Long-lived settings for plugin {displayName}; Remote Host can override Workspace.",
        "settings.dynamic.pluginSettings.title": "{displayName} Settings",
        "settings.engine.cloudExtensionSources.description": "One cloud extension source per line. Worker root URLs are supported and resolve to /magic-md/extension.json at runtime. New sources are registered in the current Engine session.",
        "settings.engine.cloudExtensionSources.title": "Cloud Extension Sources",
        "settings.engine.cloudExtensionCredentials.description": "Bearer token used for protected cloud extension descriptors, bundles, and Worker invocations.",
        "settings.engine.cloudExtensionCredentials.title": "Cloud Extension Token",
        "settings.engine.cloudPluginSources.description": "One cloud plugin source per line. Worker root URLs are supported and resolve to /magic-md/plugin.json at runtime. New sources are registered in the current Engine session.",
        "settings.engine.cloudPluginSources.title": "Cloud Plugin Sources",
        "settings.engine.cloudSidecarSources.description": "One cloud sidecar source per line. Add the Bearer token in Cloud Sidecar Token first when the Worker is protected. Worker root URLs resolve to /magic-md/sidecar.json; the RPC endpoint is inferred as /magic-md/sidecar/rpc.",
        "settings.engine.cloudSidecarSources.title": "Cloud Sidecar Sources",
        "settings.engine.cloudSidecarCredentials.description": "Bearer token used for protected cloud sidecar manifest fetches and RPC calls.",
        "settings.engine.cloudSidecarCredentials.title": "Cloud Sidecar Token",
        "settings.engine.cloudPluginCredentials.description": "Bearer token used for protected cloud plugin descriptors, bundles, and Worker invocations.",
        "settings.engine.cloudPluginCredentials.title": "Cloud Plugin Token",
        "settings.dynamic.sidecarEnabled.description": "Controls whether future sessions may auto-start Sidecar {displayName}.",
        "settings.dynamic.sidecarEnabled.fsDescription": "Built-in filesystem Sidecar. Always enabled for workspace and file dialog access.",
        "settings.dynamic.sidecarEnabled.title": "{displayName} Enabled",
        "settings.dynamic.sidecarSettings.description": "Structured runtime configuration for Sidecar {sidecarId}.",
        "settings.dynamic.sidecarSettings.title": "{displayName} Settings",
        "settings.dynamic.extensionEnabled.description": "Controls whether extension {displayName} is enabled in this layer.",
        "settings.dynamic.extensionEnabled.title": "{displayName} Enabled",
        "settings.dynamic.extensionSettings.description": "Long-term runtime configuration for extension {extensionId}.",
        "settings.dynamic.extensionSettings.title": "{displayName} Settings",
        "settings.effect.immediate": "Immediate",
        "settings.effect.nextSession": "Next session",
        "settings.effect.restart": "Restart required",
        "settings.effectAction.apply": "Apply now",
        "settings.effectAction.restartEngine": "Restart Engine now",
        "settings.effectAction.restartSidecar": "Restart Sidecar now",
        "settings.effectAction.updateSidecar": "Update Sidecar state now",
        "settings.effectNotice.nextSession": "Changes take effect in new sessions or newly started instances.",
        "settings.effectNotice.restart": "Configuration was written. Restart the corresponding host process to apply it.",
        "settings.empty.loadingSnapshot": "Loading settings snapshot",
        "settings.extensions.empty": "No extensions are installed",
        "settings.extensions.noConfig": "This extension does not expose configurable settings.",
        "settings.extensions.noSelection": "Select an extension to configure.",
        "settings.empty.noMatches": "No matching settings in this category",
        "settings.empty.selectEntry": "Select an item on the left to view details",
        "settings.empty.selectSetting": "Select a setting to view details",
        "settings.group.appearance": "Appearance",
        "settings.group.contentPresentation": "Content & Presentation",
        "settings.group.general": "General",
        "settings.groupSummary.extension": "Long-term extension settings",
        "settings.groupSummary.plugin": "Long-term plugin settings",
        "settings.groupSummary.sidecar": "Long-term Sidecar runtime settings",
        "settings.info.effect": "Effect",
        "settings.info.override": "Override",
        "settings.info.source": "Source",
        "settings.info.status": "Status",
        "settings.keepDraft": "Keep Draft",
        "settings.layer.consumer.editor": "Editor",
        "settings.layer.consumer.extension": "Extension",
        "settings.layer.consumer.pluginExecution": "Plugin execution",
        "settings.layer.consumer.workspaceSession": "Workspace session",
        "settings.layer.contextTitle": "Consumer / Scope",
        "settings.layer.current": "Current",
        "settings.layer.default": "Default",
        "settings.layer.draft": "Draft",
        "settings.layer.final": "Final",
        "settings.layer.noConfigFile": "No config file",
        "settings.layer.noWritableFile": "No writable file for this layer",
        "settings.layer.scope.remoteHost": "Current host",
        "settings.layer.scope.user": "Current user",
        "settings.layer.scope.workspace": "Current workspace",
        "settings.list.extensions": "Extensions",
        "settings.list.plugins": "Plugins",
        "settings.list.sidecars": "Sidecars",
        "settings.locale.description": "Controls the Editor and Web interface language; auto follows the system language.",
        "settings.locale.title": "Display Language",
        "settings.noExtraConfig": "No extra settings",
        "settings.noLongTermConfig": "This item only has an enable switch and no extra long-term settings.",
        "settings.override.remoteHost": "Overridden by host layer",
        "settings.override.workspace": "Overridden by workspace layer",
        "settings.preview.contentProfile.description": "Controls shared content presentation for Preview and Readonly views.",
        "settings.preview.contentProfile.title": "Content Profile",
        "settings.previewWidth.compact": "Compact",
        "settings.previewWidth.fill": "Fill",
        "settings.previewWidth.reading": "Reading",
        "settings.previewWidth.wide": "Wide",
        "settings.previewWidth.work": "Work",
        "settings.publish.presentationProfile.description": "Controls shared content presentation for Publish and Presentation.",
        "settings.publish.presentationProfile.title": "Publishing Profile",
        "settings.readOnly.builtin": "Built in",
        "settings.readOnly": "Read-only for this target",
        "settings.readOnly.cliOverride": "Overridden by CLI arguments",
        "settings.readOnly.envOverride": "Overridden by environment variables",
        "settings.reload": "Reload Settings",
        "settings.remove": "Remove",
        "settings.save": "Save",
        "settings.search.namePlaceholder": "Search names",
        "settings.search.placeholder": "Search settings",
        "settings.secretMasked": "Sensitive settings can only be viewed in masked form for now.",
        "settings.section.editor": "Editor",
        "settings.section.plugin": "Plugins",
        "settings.section.runtime": "Runtime",
        "settings.section.sidecar": "Sidecars",
        "settings.showInlineDiagnostics.description": "Shows diagnostics returned by the Engine inline in the editor.",
        "settings.showInlineDiagnostics.title": "Inline Diagnostics",
        "settings.source.default": "Default",
        "settings.source.env": "Environment",
        "settings.source.remoteHost": "Host",
        "settings.source.user": "User",
        "settings.source.workspace": "Workspace",
        "settings.stale.message": "External configuration changed; the current draft may be stale.",
        "settings.target.remoteHost": "Host",
        "settings.target.user": "User",
        "settings.target.workspace": "Workspace",
        "settings.theme.active": "Active",
        "settings.theme.currentContentProfile": "Current content profile {value}",
        "settings.theme.currentEffective": "Currently active {value}",
        "settings.theme.currentFileIconTheme": "Current file icons {value}",
        "settings.theme.currentPresentationProfile": "Current publishing profile {value}",
        "settings.theme.currentProductIconTheme": "Current icons {value}",
        "settings.theme.currentSelection": "Selected {value}",
        "settings.theme.effectiveKind": "Effective kind: {kind}",
        "settings.theme.kind.dark": "Dark",
        "settings.theme.kind.hcDark": "HC Dark",
        "settings.theme.kind.hcLight": "HC Light",
        "settings.theme.kind.light": "Light",
        "settings.theme.preview.body": "Body",
        "settings.theme.preview.sample": "Aa Sample",
        "settings.theme.profileSample": "This fixed sample text previews changes in font size, width, line height, and paragraph rhythm.",
        "settings.theme.scope.content": "Content",
        "settings.theme.scope.presentation": "Presentation",
        "settings.title": "Settings",
        "settings.value.defaultValue": "Default {value}",
        "settings.value.emptyList": "Empty list",
        "settings.value.emptyObject": "Empty object",
        "settings.value.inheritDefault": "Inherited default",
        "settings.value.items": "items",
        "settings.value.unset": "Unset",
        "settings.value.useDefault": "Use default",
        "sidebar.engine": "Engine",
        "sidebar.engineConnector": "Engine Connector Settings",
        "sidebar.explorer": "Explorer",
        "sidebar.openFiles": "Open Files",
        "sidebar.publish": "Publish",
        "sidebar.search": "Search",
        "sidebar.settings": "Settings",
        "sidebar.toc": "Table of Contents",
        "status.all": "All",
        "status.error": "Error",
        "status.loading": "Loading",
        "status.pending": "Pending",
        "status.running": "Running",
        "status.starting": "Starting",
        "status.stopped": "Stopped",
        "status.stopping": "Stopping",
        "status.success": "Success",
        "statusbar.activity.completed": "Completed",
        "statusbar.activity.execute": "Execute",
        "statusbar.activity.failed": "Failed",
        "statusbar.activity.read": "Read",
        "statusbar.activity.write": "Write",
        "statusbar.cursor": "Ln {line}, Col {col}",
        "statusbar.definitions": "{count} definitions",
        "statusbar.details.definitions": "Definitions",
        "statusbar.details.encoding": "Encoding",
        "statusbar.details.format": "Format",
        "statusbar.details.open": "Show status details",
        "statusbar.details.plugins": "Plugins",
        "statusbar.details.sessions": "Sessions",
        "statusbar.details.sidecars": "Sidecars",
        "statusbar.details.title": "Status details",
        "statusbar.documentStats": "{lines} lines · {words} words",
        "statusbar.execution.errorAria": "{count} execution errors",
        "statusbar.execution.moreErrors": "{count} more errors",
        "statusbar.execution.viewLogs": "View logs",
        "statusbar.logs.hide": "Hide logs",
        "statusbar.logs.show": "Show logs",
        "statusbar.mcp.detailTitle": "MCP details",
        "statusbar.mcp.start": "Start MCP Server",
        "statusbar.mcp.stop": "Stop MCP Server",
        "statusbar.mcp.suffix.error": " error",
        "statusbar.mcp.suffix.starting": " starting",
        "statusbar.mcp.suffix.stopping": " stopping",
        "statusbar.plugins": "{count} plugins",
        "statusbar.plugins.loading": "Loading plugins",
        "statusbar.plugins.loadingMore": "Loading {name} +{count}",
        "statusbar.plugins.loadingNamed": "Loading {name}",
        "statusbar.plugins.ready": "{count} plugins ready",
        "statusbar.ref.notExecuted": "{count} refs not executed",
        "statusbar.ref.notFound": "{count} refs not found",
        "statusbar.sessions.label": "{count} sessions",
        "statusbar.sessions.title": "{count} active sessions",
        "statusbar.sidecars.label": "{count} Sidecars",
        "statusbar.sidecars.title": "{count} active Sidecars",
        "statusbar.source.externalEdit": "External edit",
        "statusbar.source.unknown": "Unknown source",
        "statusbar.tools.addRender": "Add render",
        "statusbar.tools.cancelExecution": "Cancel execution",
        "statusbar.tools.closeDocument": "Close document",
        "statusbar.tools.createContentBlock": "Create content block",
        "statusbar.tools.createDefinition": "Create definition",
        "statusbar.tools.createForBlock": "Create for block",
        "statusbar.tools.createImport": "Create import",
        "statusbar.tools.createMeta": "Create meta",
        "statusbar.tools.createUseBlock": "Create use block",
        "statusbar.tools.deleteContentBlock": "Delete content block",
        "statusbar.tools.deleteDefinition": "Delete definition",
        "statusbar.tools.deleteForBlock": "Delete for block",
        "statusbar.tools.deleteImport": "Delete import",
        "statusbar.tools.deleteRender": "Delete render",
        "statusbar.tools.deleteUseBlock": "Delete use block",
        "statusbar.tools.editContentBlock": "Edit content block",
        "statusbar.tools.editDefinition": "Edit definition",
        "statusbar.tools.editForBlock": "Edit for block",
        "statusbar.tools.editImport": "Edit import",
        "statusbar.tools.editMeta": "Edit meta",
        "statusbar.tools.editUseBlock": "Edit use block",
        "statusbar.tools.getDocumentContent": "Get document content",
        "statusbar.tools.getExecutionState": "Get execution state",
        "statusbar.tools.getPluginSchema": "Get plugin schema",
        "statusbar.tools.getPluginRuntimeInfo": "Get plugin runtime info",
        "statusbar.tools.insertText": "Insert text",
        "statusbar.tools.listDefinitions": "List definitions",
        "statusbar.tools.listDocuments": "List documents",
        "statusbar.tools.listFiles": "List files",
        "statusbar.tools.listPlugins": "List plugins",
        "statusbar.tools.openDocument": "Open document",
        "statusbar.tools.readOutput": "Read output",
        "statusbar.tools.renameDefinition": "Rename definition",
        "statusbar.tools.replaceText": "Replace text",
        "statusbar.tools.startExecution": "Start execution",
        "statusbar.tools.validateDocument": "Validate document",
        "pluginDetail.action.openSettings": "Open Settings",
        "pluginDetail.action.goBack": "Go back",
        "pluginDetail.api.empty": "No APIs match the filter",
        "pluginDetail.api.filterPlaceholder": "Filter APIs",
        "pluginDetail.api.noProperties": "No properties declared",
        "pluginDetail.api.noSelection": "Select an API",
        "pluginDetail.api.paramsSchema": "Request params schema",
        "pluginDetail.api.rawSchema": "Raw schema",
        "pluginDetail.api.resultSchema": "Result data schema",
        "pluginDetail.backendBinding": "Backend Binding",
        "pluginDetail.configParameters": "Config Parameters",
        "pluginDetail.detailTitle": "Plugin Detail",
        "pluginDetail.documentInstances": "Document Instances",
        "pluginDetail.documentEffect": "Document",
        "pluginDetail.effect.none": "none",
        "pluginDetail.effect.read": "read",
        "pluginDetail.effect.write": "write",
        "pluginDetail.error": "Error",
        "pluginDetail.externalEffect": "External",
        "pluginDetail.hasOutput": "Has Output",
        "pluginDetail.homepage": "Homepage",
        "pluginDetail.installed": "Installed",
        "pluginDetail.markdown": "Markdown",
        "pluginDetail.noOutput": "No Output",
        "pluginDetail.notFound": "Plugin \"{name}\" not found",
        "pluginDetail.outputSchema": "Output Schema",
        "pluginDetail.overview": "Overview",
        "pluginDetail.primary": "Primary",
        "pluginDetail.dangerous": "Dangerous",
        "pluginDetail.render.block": "Block",
        "pluginDetail.render.inline": "Inline",
        "pluginDetail.renderModes": "Render Modes",
        "pluginDetail.runtimeApis": "Runtime APIs",
        "pluginDetail.section.actions": "Actions",
        "pluginDetail.smartIntake": "Smart Intake",
        "pluginDetail.smartIntake.accepts": "Accepts",
        "pluginDetail.smartIntake.dynamicAccepts": "Dynamic",
        "pluginDetail.smartIntake.kind.file": "File",
        "pluginDetail.smartIntake.kind.folder": "Folder",
        "pluginDetail.smartIntake.kind.har": "HAR",
        "pluginDetail.smartIntake.kind.html": "HTML",
        "pluginDetail.smartIntake.kind.json": "JSON",
        "pluginDetail.smartIntake.kind.magic-fragment": "Magic fragment",
        "pluginDetail.smartIntake.kind.table": "Table",
        "pluginDetail.smartIntake.kind.text": "Text",
        "pluginDetail.smartIntake.kind.url": "URL",
        "pluginDetail.smartIntake.provider.runtime": "Runtime",
        "pluginDetail.smartIntake.provider.ui": "UI",
        "pluginDetail.sourceInfo": "Source Info",
        "pluginDetail.staticBinding": "Static Binding",
        "pluginDetail.staticBindings": "Static Bindings",
        "pluginDetail.timeoutSecs": "Timeout {seconds}s",
        "pluginDetail.usageExamples": "Usage Examples",
        "pluginSource.cloudBundle": "Cloud Bundle",
        "pluginSource.cloudBundle.tooltip": "Downloaded from a cloud source and executed locally",
        "pluginSource.cloudWorker": "Cloud Worker",
        "pluginSource.cloudWorker.tooltip": "Executes remotely on a Cloudflare Worker",
        "pluginSource.detail.apiUrl": "API URL",
        "pluginSource.detail.bundleBaseUrl": "Bundle Base URL",
        "pluginSource.detail.deployedVersion": "Deployed Version",
        "pluginSource.detail.healthUrl": "Health URL",
        "pluginSource.detail.host": "Host",
        "pluginSource.detail.invokeUrl": "Invoke URL",
        "pluginSource.detail.manifestUrl": "Manifest URL",
        "pluginSource.detail.pluginAddress": "Plugin Address",
        "pluginSource.detail.provider": "Provider",
        "pluginSource.detail.publishUrl": "Publish URL",
        "pluginSource.detail.remoteUrl": "Remote URL",
        "pluginSource.detail.smartIntakeBuildPlanUrl": "Smart Intake Build Plan URL",
        "pluginSource.detail.smartIntakeProposeUrl": "Smart Intake Propose URL",
        "pluginSource.detail.type": "Type",
        "pluginSource.filter.all": "All",
        "pluginSource.local": "Local",
        "pluginSource.local.tooltip": "Loaded from local plugin files",
        "pluginPanel.action.openDetail": "Open Detail",
        "pluginPanel.action.run": "Run",
        "pluginPanel.action.runAll": "Run All",
        "pluginPanel.action.runAllTitle": "Run all plugins in dependency order",
        "pluginPanel.action.runContent": "Run content",
        "pluginPanel.action.runFor": "Run for loop",
        "pluginPanel.action.runImport": "Run import",
        "pluginPanel.action.runUse": "Run use",
        "pluginPanel.action.stop": "Stop",
        "pluginPanel.action.stopFor": "Stop for loop",
        "pluginPanel.action.stopRun": "Stop run",
        "pluginPanel.empty.addHint": "Use {syntax} to add",
        "pluginPanel.empty.noInstances": "No plugin instances",
        "pluginPanel.filterPlaceholder": "Filter instances...",
        "pluginPanel.instances": "Instances",
        "pluginPanel.noMatches": "No instances matching \"{query}\"",
        "pluginPanel.section.content": "Content",
        "pluginPanel.section.define": "Define",
        "pluginPanel.section.for": "For",
        "pluginPanel.section.import": "Import",
        "pluginPanel.section.use": "Use",
        "pluginPanel.status.done": "Done",
        "pluginPanel.status.running": "Running",
        "pluginPanel.type.static": "static",
        "pluginPanel.type.template": "template",
        "publish.action.cancel": "Cancel",
        "publish.action.cancelPublish": "Cancel Publish",
        "publish.action.copySiteUrl": "Copy site URL",
        "publish.action.republish": "Publish again",
        "publish.action.retry": "Retry",
        "publish.action.saveConfig": "Save Config",
        "publish.action.start": "Start Publish",
        "publish.action.startPreviewServer": "Start preview server",
        "publish.action.startSite": "Publish Site",
        "publish.action.stopPreviewServer": "Stop preview server",
        "publish.action.stopServer": "Stop server",
        "publish.baseUrlHelp": "Used to generate sitemap (optional)",
        "publish.buildStrategy.full": "Full build",
        "publish.buildStrategy.incrementalHash": "Incremental build (content hash cache)",
        "publish.chooseDocumentOutputDir": "Choose single-document publish output directory",
        "publish.chooseFolderOutputDir": "Choose folder publish output directory",
        "publish.commaSeparated": "(comma-separated)",
        "publish.completed": "Site publish completed",
        "publish.contentSource.diskFile": "Disk file",
        "publish.contentSource.openBuffer": "Current editor content",
        "publish.customDocumentOutDirWarning": "Custom output directories are not mounted into the current document's publish package; the package still keeps configuration, status, and report files.",
        "publish.defaultOutDirHelp": "Leave empty to use the default directory: {dir}",
        "publish.document": "Publish Document",
        "publish.documentRunningHint": "This document already has a publish task running. Check publish.status.json in the publish package for live status.",
        "publish.error.outDirRequired": "Output directory is required.",
        "publish.error.startFailed": "Publish failed to start. Check publish.status.json or Engine status.",
        "publish.failed": "Site publish failed",
        "publish.field.buildStrategy": "Build strategy",
        "publish.field.contentSource": "Content source",
        "publish.field.baseUrl": "Base URL",
        "publish.field.exclude": "Exclude patterns",
        "publish.field.include": "Include patterns",
        "publish.field.outputDir": "Output directory",
        "publish.field.siteTitle": "Site title",
        "publish.field.themeSnapshot": "Theme snapshot",
        "publish.field.workspacePath": "Workspace path",
        "publish.option.clean": "Clean output directory",
        "publish.option.incrementalHash": "Incremental build (based on content hash cache)",
        "publish.option.incremental": "Incremental build (skip unchanged documents)",
        "publish.option.rerunAll": "Rerun all definitions",
        "publish.option.useOpenBuffer": "Use current editor content",
        "publish.option.useOpenBufferWithUnsaved": "Use current editor content (includes unsaved changes)",
        "publish.folder": "Publish Folder",
        "publish.folderBadge": "Folder",
        "publish.folderTitle.completed": "Folder Publish - Completed",
        "publish.folderTitle.failed": "Folder Publish - Failed",
        "publish.folderTitle.running": "Folder Publish - Running",
        "publish.generatedAt": "Generated at: {generatedAt}",
        "publish.noOpenBuffer": "The current file is not open in the editor. This publish will read from disk.",
        "publish.notSet": "Not set",
        "publish.outputPath": "Output: {outputDir}",
        "publish.package": "Publish Package",
        "publish.pageList": "Pages",
        "publish.pageProgress": "Page progress",
        "publish.placeholder.siteTitle": "My Site",
        "publish.previewServer": "Preview server",
        "publish.running": "Publishing site...",
        "publish.processingProgress": "Progress: {processed}/{total} pages",
        "publish.serverRunning": "Running",
        "publish.serverStarting": "Starting server...",
        "publish.singleDocument": "Single document",
        "publish.stat.built": "Built",
        "publish.stat.cached": "Cached",
        "publish.stat.failed": "Failed",
        "publish.stat.total": "Total",
        "publish.status.built": "Built",
        "publish.status.cached": "Cached",
        "publish.status.configSaved": "Publish configuration saved",
        "publish.status.configSavedInPackage": "Publish configuration saved. It is available in the publish package.",
        "publish.status.failed": "Publish failed: {message}",
        "publish.title": "Site Publish",
        "publish.totalPages": "Total {total} pages",
        "publish.unsavedChanges": "Unsaved changes",
        "publish.untitledSite": "Untitled site",
        "publish.unknownError": "Unknown error",
        "publish.warning.invalidConfig": "The existing config file is invalid. Defaults have been restored.",
        "publish.warning.readConfigFailed": "Failed to read saved config: {message}",
        "engineDetail.description": "JSON-RPC 2.0 over stdio. Manages plugin execution, sidecar processes, and document orchestration.",
        "engineDetail.activity.activeFilter": "Active",
        "engineDetail.activity.activeSession": "Active session: {name}",
        "engineDetail.activity.all": "All activity",
        "engineDetail.activity.empty": "No matching sessions.",
        "engineDetail.activity.emptyState": "Open a document or run a plugin to see sessions and executions here.",
        "engineDetail.activity.executionTotal": "Total executions",
        "engineDetail.activity.filterPlaceholder": "Filter sessions...",
        "engineDetail.activity.index": "Activity index",
        "engineDetail.activity.noAction": "No action name",
        "engineDetail.activity.noActiveSession": "No active session.",
        "engineDetail.activity.noExecutionDetail": "This execution has no output, error, or progress details yet.",
        "engineDetail.activity.noSessionSelected": "Select a session on the left to inspect its execution activity.",
        "engineDetail.activity.openSession": "View session",
        "engineDetail.activity.overview": "Activity Overview",
        "engineDetail.activity.progress": "Progress",
        "engineDetail.activity.title": "Session Activity",
        "engineDetail.activity.withActivity": "With activity",
        "engineDetail.executionActivity": "Execution Activity",
        "engineDetail.execution.cached": "Cached",
        "engineDetail.execution.currently": "Currently",
        "engineDetail.execution.empty": "No executions yet. Run a plugin to see execution activity here.",
        "engineDetail.execution.failed": "Failed",
        "engineDetail.execution.idle": "Idle",
        "engineDetail.execution.output": "Output",
        "engineDetail.execution.runAllProgress": "Run All in Progress",
        "engineDetail.execution.started": "Started",
        "engineDetail.execution.duration": "Duration",
        "engineDetail.execution.action": "Action",
        "engineDetail.execution.filterPlaceholder": "Filter executions...",
        "engineDetail.execution.noMatches": "No matching executions.",
        "engineDetail.protocol.events": "Server -> Client Events",
        "engineDetail.protocol.event": "Event",
        "engineDetail.protocol.dir": "Dir",
        "engineDetail.protocol.framing": "Framing",
        "engineDetail.protocol.methods": "RPC Methods",
        "engineDetail.protocol.method": "Method",
        "engineDetail.server": "Engine Server",
        "engineDetail.starting": "Engine Server is starting...",
        "engineDetail.notRunning": "Engine Server is not running",
        "engineDetail.autoStartHint": "The Engine Server will start automatically when the application launches.",
        "previewWidth.adjust": "Adjust preview width",
        "previewWidth.adjustTitle": "Adjust preview width: {label}",
        "previewWidth.compact": "Compact",
        "previewWidth.custom": "Custom",
        "previewWidth.customWithWidth": "Custom {width}px",
        "previewWidth.fill": "Fill",
        "previewWidth.reading": "Reading",
        "previewWidth.reset": "Reset width",
        "previewWidth.wide": "Wide",
        "previewWidth.work": "Work",
        "pane.close": "Close pane",
        "pane.collapse": "Collapse pane",
        "pane.count": "{count} panes",
        "pane.defaultTitle": "Pane",
        "pane.dropHere": "Drop into this pane",
        "pane.expand": "Expand pane",
        "pane.expandGroup": "Expand pane group",
        "pane.expandGroupWithTitle": "Expand pane group {title}",
        "pane.expandWithTitle": "Expand pane {title}",
        "pane.resizeEditorPreview": "Resize editor and preview width",
        "pane.resizeHorizontal": "Resize left and right panes",
        "pane.resizeVertical": "Resize upper and lower panes",
        "pane.splitDown": "Create pane below",
        "pane.splitRight": "Create pane to the right",
        "pane.unsavedChanges": "Unsaved changes",
        "platform.applyUnsupported": "This setting does not need a separate apply action.",
        "platform.engineReconnected": "Engine reconnected. Future sessions will use the new configuration.",
        "platform.engineRestartFailed": "Engine restart failed.",
        "platform.engineRestarted": "Engine restarted.",
        "platform.restartUnsupported": "The current connection mode does not support restarting the host process from the client.",
        "platform.sidecarIdInvalid": "Cannot identify the Sidecar id.",
        "platform.cloudSidecarSettingsApplied": "{sidecarId} settings saved. Cloud sidecars do not start a local process.",
        "platform.sidecarRestarted": "{sidecarId} restarted with the new settings.",
        "platform.sidecarStarted": "{sidecarId} started.",
        "platform.sidecarStopped": "{sidecarId} stopped.",
        "platform.webRestartUnsupported": "Web mode cannot restart a remote Engine/Gateway from here.",
        "definitionPanel.actions": "Actions",
        "definitionPanel.config": "Config",
        "definitionPanel.discard": "Discard",
        "definitionPanel.output": "Output",
        "definitionPanel.outputDuration": "Last execution took {duration}ms",
        "definitionPanel.saveConfigTitle": "Save config to document",
        "definitionPanel.switchToJson": "Switch to JSON editing",
        "definitionPanel.switchToVisual": "Switch to visual editing",
        "definitionPanel.unsavedConfig": "Unsaved config changes",
        "copy.bodyReference": "Copy body reference",
        "copy.config": "Copy config",
        "copy.contentBody": "Copy content body",
        "copy.definitionSnippet": "Copy definition snippet",
        "copy.documentPath": "Copy document path",
        "copy.id": "Copy ID",
        "copy.forSnippet": "Copy loop snippet",
        "copy.loopSource": "Copy loop source",
        "copy.output": "Copy output",
        "copy.path": "Copy path",
        "copy.reference": "Copy reference",
        "copy.failed": "Copy failed",
        "copy.referenceHint": "Copy reference; right-click for more copy actions",
        "copy.renderStatement": "Copy render statement",
        "render.action.debug": "Debug",
        "render.action.rerun": "Re-run",
        "render.action.run": "Run",
        "render.component": "Component",
        "render.configureUse": "Configure use",
        "render.content.failedMessage": "Content execution failed",
        "render.content.instance": "Content instance",
        "render.content.notRunMessage": "Not run yet. Run it to show the Content result here.",
        "render.content.parsing": "Parsing",
        "render.content.parsingEllipsis": "Parsing...",
        "render.content.parsingMessage": "Content is parsing and will show the result here when complete.",
        "render.content.scoped": "Nested Content",
        "render.deps.jumpTo": "Jump to {id}",
        "render.deps.noPredecessors": "No predecessors",
        "render.deps.noSuccessors": "No successors",
        "render.deps.predecessors": "Predecessors · {id}",
        "render.deps.successors": "Successors · {id}",
        "render.deps.title": "Predecessors / successors",
        "render.expandUnit": "Expand {id}",
        "render.fullscreen.adjustWidth": "Adjust fullscreen width",
        "render.fullscreen.adjustWidthTitle": "Adjust fullscreen width: {label}",
        "render.fullscreen.enter": "Workspace fullscreen",
        "render.fullscreen.exit": "Exit workspace fullscreen",
        "render.fullscreen.resizeLeft": "Drag left to resize fullscreen width; double-click to reset",
        "render.fullscreen.resizeRight": "Drag right to resize fullscreen width; double-click to reset",
        "render.fullscreen.resizeTitle": "Drag to resize width; double-click to reset",
        "render.importRunning": "import {namespace} running...",
        "render.importDocument.imported": "Imported",
        "render.importDocument.label": "Imported document",
        "render.importDocument.refreshing": "Refreshing",
        "render.inlineRef.contentNotFound": "Content definition not found: {ref}",
        "render.inlineRef.notExecuted": "Not executed: {ref}",
        "render.inlineRef.pathMissing": "Path does not exist: {ref}",
        "render.inlineRef.unitNotFound": "Unit not found: {ref}",
        "render.kind.definition": "Definition",
        "render.kind.forLoop": "For loop",
        "render.missingParams": "Missing: {params}",
        "render.params": "Params: {params}",
        "render.pinToSidebar": "Add to sidebar",
        "render.placeholder.externalOutput": "External output is available and will load when scrolled into view.",
        "render.placeholder.importNotRun": "Import output has not been loaded yet. Running will refresh the source snapshot.",
        "render.placeholder.loadingOutput": "Loading output...",
        "render.placeholder.loadingPlugin": "Loading plugin UI...",
        "render.placeholder.notRun": "Not run yet. Run it to show the component result here.",
        "render.placeholder.noRenderer": "The plugin has no Renderer, so the component result cannot be shown in Preview.",
        "render.placeholder.outputLoadFailed": "Output load failed: {error}",
        "render.placeholder.outputLoadFailedShort": "Output load failed",
        "render.rerunImport": "Rerun import {namespace}",
        "render.runImport": "Run import {namespace}",
        "render.runUnit": "Run {id}",
        "render.for.collapseAll": "Collapse all",
        "render.for.collapseAllIterations": "Collapse all iterations",
        "render.for.expandAll": "Expand all",
        "render.for.expandAllIterations": "Expand all iterations",
        "render.for.failedCount": "{count} failed",
        "render.for.source": "Source",
        "render.for.sourceTitle": "Source: {source}",
        "render.status.failed": "Run failed",
        "render.status.importing": "Importing",
        "render.status.loadFailed": "Load failed",
        "render.status.notRun": "Not run",
        "render.status.notInstalled": "Not installed",
        "render.status.notRenderable": "Not renderable",
        "render.status.pendingLoad": "Pending load",
        "render.status.ran": "Ran",
        "render.status.rendered": "Rendered",
        "render.status.runningEllipsis": "Running...",
        "render.template.configure": "Configure template",
        "render.template.message": "Templates do not execute directly. Instantiate them through ::use to render.",
        "render.template.status": "{kind} template",
        "render.templateUsage.message": "{location} uses template params but is not marked template=\"true\".",
        "render.templateUsage.missingTemplate": "Missing template",
        "render.unpin": "Remove from sidebar",
        "render.useIncomplete.message": "Missing required template params: {missing}. Fill them in ::use[{id}] with before rendering.",
        "render.useIncomplete.status": "Use instance incomplete",
        "render.useTemplate.message": "This ::use is still a template alias and will not execute directly. Instantiate it through another ::use to render.",
        "render.useTemplate.status": "Use template",
        "preview.audio": "Audio",
        "preview.emptyFile": "File is empty",
        "preview.imageLoadFailed": "Image load failed",
        "preview.jsonParseFailed": "JSON parse failed: {message}",
        "preview.noContent": "No content",
        "preview.noDiff": "No diff",
        "preview.noFilePath": "No file path specified",
        "preview.openInDesktop": "Open in the desktop Editor",
        "preview.resizeLeft": "Drag left to resize preview width; double-click to reset",
        "preview.resizeRight": "Drag right to resize preview width; double-click to reset",
        "preview.snapshot.closePreview": "Close preview",
        "preview.snapshot.content": "Content",
        "preview.snapshot.diff": "Diff",
        "preview.snapshot.file": "File",
        "preview.snapshot.next": "Next snapshot",
        "preview.snapshot.previous": "Previous snapshot",
        "preview.snapshot.trigger.auto": "Auto",
        "preview.snapshot.trigger.manual": "Manual",
        "preview.html.title": "HTML Preview",
        "preview.svgRenderFailed": "SVG render failed",
        "preview.svgSourceEmpty": "SVG source is empty",
        "preview.tablePreview": "Table preview",
        "preview.tableStats": "{rows} rows · {columns} columns",
        "preview.tableTruncated": "showing first {maxRows}",
        "preview.unsupportedImage": "This platform does not support local image preview",
        "preview.unsupportedMedia": "This platform does not support local media preview",
        "preview.unsupportedPdf": "This platform does not support local PDF preview",
        "preview.video": "Video",
        "log.advancedFilters": "Advanced filters",
        "log.clearAll": "Clear all logs",
        "log.collapsePanel": "Collapse log panel",
        "log.detail": "Log Detail",
        "log.field.data": "Data",
        "log.field.definition": "Definition",
        "log.field.level": "Level",
        "log.field.message": "Message",
        "log.field.plugin": "Plugin",
        "log.field.source": "Source",
        "log.field.stack": "Stack",
        "log.field.time": "Time",
        "log.maximizeHeight": "Maximize height",
        "log.panelViews": "Log panel views",
        "log.resizePanel": "Resize bottom panel height",
        "log.restoreHeight": "Restore default height",
        "log.searchPlaceholder": "Search logs...",
        "log.source.engine": "Engine",
        "log.source.mcp": "MCP",
        "log.source.parser": "Parser",
        "log.source.plugin": "Plugin",
        "log.source.extension": "Extension",
        "log.source.resolver": "Resolver",
        "log.source.sidecar": "Sidecar",
        "log.source.system": "System",
        "log.source.transport": "Transport",
        "log.source.ui": "UI",
        "log.tab.debug": "Debug",
        "log.tab.logs": "Logs",
        "log.tab.timeline": "Timeline",
        "log.tab.trace": "Trace",
        "log.tab.watches": "Watches",
        "log.title": "Logs",
        "log.toggleLevel": "Toggle {level} logs",
        "trace.clear": "Clear",
        "trace.cloudWorker": "Cloud worker",
        "trace.cloudSidecar": "Cloud sidecar",
        "trace.closeDetails": "Close details",
        "trace.collapseDetails": "Collapse details",
        "trace.collapseRuns": "Collapse runs",
        "trace.copyJson": "Copy Trace JSON",
        "trace.copyJsonShort": "Copy JSON",
        "trace.copyPath": "Copy Trace Path",
        "trace.copySpanJson": "Copy span JSON",
        "trace.delete": "Delete Trace",
        "trace.deleted": "Trace deleted: {traceId}",
        "trace.deleteConfirm": "Delete trace {traceId}?",
        "trace.details": "Details",
        "trace.duration": "Duration",
        "trace.empty": "No execution traces captured",
        "trace.error": "Error",
        "trace.events": "Events",
        "trace.extension": "Extension",
        "trace.gotoDefinition": "Go to definition",
        "trace.gotoDefinitionLine": "Go to definition line {line}",
        "trace.noEvents": "No events",
        "trace.noStructuredPayload": "No structured payload",
        "trace.noTraces": "No traces",
        "trace.output": "Output",
        "trace.params": "Params",
        "trace.plugin": "Plugin",
        "trace.pluginAction": "Plugin action",
        "trace.pluginInput": "Plugin input",
        "trace.pluginResult": "Plugin result",
        "trace.raw": "Raw",
        "trace.recording": "Recording",
        "trace.request": "Request",
        "trace.resizeDetails": "Resize trace details",
        "trace.resizeRuns": "Resize trace run list",
        "trace.resolvedConfig": "Resolved config",
        "trace.response": "Response",
        "trace.result": "Result",
        "trace.runAll": "Run all",
        "trace.running": "running",
        "trace.runs": "Runs",
        "trace.runUnit": "Run unit",
        "trace.runUnitWithId": "Run {unitId}",
        "trace.save": "Save Trace",
        "trace.saved": "Trace saved: {traceId}",
        "trace.saveFailed": "Trace save failed: {message}",
        "trace.saveFailedMissingDocument": "Trace save failed: document path is missing",
        "trace.showDetails": "Show details",
        "trace.showRuns": "Show runs",
        "trace.sidecar": "Sidecar",
        "trace.sidecarCall": "Sidecar call",
        "trace.sidecarEnsure": "Sidecar ensure",
        "trace.sidecarParams": "Sidecar params",
        "trace.sidecarResult": "Sidecar result",
        "trace.span": "Span",
        "trace.start": "Start Trace",
        "trace.stop": "Stop Trace",
        "trace.title": "Trace",
        "trace.traceRun": "Trace run",
        "trace.unit": "Unit",
        "trace.waitingEvents": "Waiting for execution events",
        "trace.waterfall": "Waterfall",
        "watch.add": "Add",
        "watch.addButton": "Watch",
        "watch.adding": "Adding",
        "watch.addWatch": "Add watch",
        "watch.closeAdd": "Close add watch",
        "watch.collapseDetails": "Collapse watch details",
        "watch.collapseDetailsTitle": "Collapse details",
        "watch.column": "Watch",
        "watch.counts": "{watches} watches / {points} points",
        "watch.detail.change": "Change",
        "watch.detail.currentValue": "Current value",
        "watch.detail.diff": "Diff",
        "watch.detail.previousValue": "Previous value",
        "watch.detailTab.diff": "Diff",
        "watch.detailTab.meta": "Meta",
        "watch.detailTab.values": "Values",
        "watch.details": "Details",
        "watch.empty": "Add a watch to trace output changes.",
        "watch.error.noActiveSession": "No active engine session",
        "watch.error.requiresUnitExpression": "Output watch requires a unit expression",
        "watch.expressionLabel": "Watch expression",
        "watch.expressionPlaceholder": "unit.output.path",
        "watch.includePartial": "partial",
        "watch.inspectPoint": "Inspect {label} at {time}",
        "watch.meta.event": "Event",
        "watch.meta.path": "Path",
        "watch.meta.unit": "Unit",
        "watch.newer": "Newer",
        "watch.noActiveDocument": "No active document",
        "watch.older": "Older",
        "watch.pointTitle": "{time} {summary}",
        "watch.remove": "Remove watch",
        "watch.removeAria": "Remove {label}",
        "watch.resizeDetails": "Resize watch details panel",
        "watch.resizeDetailsTitle": "Resize details",
        "watch.resizeLabelColumn": "Resize watch label column",
        "watch.resizeLabelColumnTitle": "Resize watch column",
        "watch.showInWatches": "Show in Watches",
        "watch.suggestion.arrayIndex": "array index",
        "watch.suggestion.valueRoot": "value root",
        "watch.summary.arrayChanged": "array changed ({count})",
        "watch.summary.arrayLength": "array length {previous} -> {next}",
        "watch.summary.failed": "failed: {error}",
        "watch.summary.initial": "initial {value}",
        "watch.summary.objectChanged": "object changed",
        "watch.summary.objectKeys": "object keys {parts}",
        "watch.timelineHelp": "Left to right is change order. Dots are value changes.",
        "watch.value.array": "array({count})",
        "watch.value.object": "object({count})",
        "sidecarPanel.empty": "No sidecars registered",
        "sidecarPanel.cloudSource": "Cloud sidecar",
        "sidecarPanel.filter.all": "All sidecars",
        "sidecarPanel.filter.cloud": "Cloud sidecars",
        "sidecarPanel.filter.local": "Local sidecars",
        "sidecarPanel.noMatching": "No matching sidecars",
        "sidecarPanel.searchPlaceholder": "Search sidecars...",
        "sidecarPanel.shutdown": "Shutdown",
        "sidecarSource.cloud": "Cloud Sidecar",
        "sidecarSource.cloud.tooltip": "Runs remotely through a cloud sidecar endpoint",
        "sidecarSource.detail.command": "Command",
        "sidecarSource.detail.deployedVersion": "Deployed Version",
        "sidecarSource.detail.endpoint": "RPC Endpoint",
        "sidecarSource.detail.healthUrl": "Health URL",
        "sidecarSource.detail.host": "Host",
        "sidecarSource.detail.manifestUrl": "Manifest URL",
        "sidecarSource.detail.provider": "Provider",
        "sidecarSource.detail.sourceId": "Source ID",
        "sidecarSource.detail.sourceUrl": "Source URL",
        "sidecarSource.detail.transport": "Transport",
        "sidecarSource.detail.type": "Type",
        "sidecarSource.local": "Local Sidecar",
        "sidecarSource.local.tooltip": "Runs as a local sidecar process",
        "vscodeWebview.config.apply": "Apply",
        "vscodeWebview.config.applyAndRun": "Apply & Run",
        "vscodeWebview.config.discard": "Discard",
        "vscodeWebview.config.visual": "Visual",
        "vscodeWebview.emptyPreview": "Open a Markdown file with Magic MD definitions to see preview.",
        "vscodeWebview.previewWidth.full": "Full width",
        "vscodeWebview.previewWidth.medium": "Medium (48rem)",
        "vscodeWebview.previewWidth.prose": "Prose (65ch)",
        "vscodeWebview.previewWidth.wide": "Wide (64rem)",
        "vscodeWebview.sidecarCallTimedOut": "Sidecar call timed out",
        "mcpDetail.clearLogs": "Clear logs",
        "mcpDetail.annotation.destructive": "destructive",
        "mcpDetail.annotation.readOnly": "read-only",
        "mcpDetail.clients.all": "All clients",
        "mcpDetail.clients.connected": "Connected Clients",
        "mcpDetail.clients.empty": "No clients connected. Configure Claude Desktop, Cursor, or another MCP client to connect.",
        "mcpDetail.clients.filterPlaceholder": "Filter clients...",
        "mcpDetail.clients.startHint": "Start the MCP server to see connected clients.",
        "mcpDetail.clients.stateless": "Stateless requests",
        "mcpDetail.clients.status.connected": "Connected",
        "mcpDetail.clients.status.disconnected": "Disconnected",
        "mcpDetail.clients.title": "Clients",
        "mcpDetail.clients.unknown": "Unknown Client",
        "mcpDetail.filterPlaceholder": "Filter by tool/method name...",
        "mcpDetail.info.clients": "Clients",
        "mcpDetail.info.endpoint": "Endpoint",
        "mcpDetail.info.notStarted": "(not started)",
        "mcpDetail.info.prompts": "Prompts",
        "mcpDetail.info.protocol": "Protocol",
        "mcpDetail.info.resources": "Resources",
        "mcpDetail.info.serverName": "Server Name",
        "mcpDetail.info.tools": "Tools",
        "mcpDetail.info.transport": "Transport",
        "mcpDetail.info.version": "Version",
        "mcpDetail.logs.empty": "No matching logs.",
        "mcpDetail.logs.logId": "Log ID",
        "mcpDetail.logs.method": "Method",
        "mcpDetail.logs.noDetails": "No request params or response body captured.",
        "mcpDetail.logs.noParams": "No params captured for this request.",
        "mcpDetail.logs.noResponse": "No response body captured.",
        "mcpDetail.logs.params": "JSON-RPC Params",
        "mcpDetail.logs.request": "Request Logs",
        "mcpDetail.logs.requestId": "Request ID",
        "mcpDetail.logs.response": "JSON-RPC Response",
        "mcpDetail.logs.responseSize": "Response size",
        "mcpDetail.logs.responseStatus": "HTTP",
        "mcpDetail.logs.responseTruncated": "Response body truncated",
        "mcpDetail.logs.session": "Session",
        "mcpDetail.logs.startHint": "Start the MCP server to see request logs.",
        "mcpDetail.logs.status.error": "Error",
        "mcpDetail.logs.status.pending": "Pending",
        "mcpDetail.logs.status.success": "Success",
        "mcpDetail.logs.timestamp": "Timestamp",
        "mcpDetail.overview": "Overview",
        "mcpDetail.prompts.empty": "No prompts registered.",
        "mcpDetail.prompts.startHint": "Start the MCP server to see registered prompts.",
        "mcpDetail.resources.empty": "No resources registered.",
        "mcpDetail.resources.startHint": "Start the MCP server to see registered resources.",
        "mcpDetail.resource.template": "template",
        "mcpDetail.serverSubtitle": "MCP Server — Model Context Protocol",
        "mcpDetail.status.error": "Error",
        "mcpDetail.status.running": "Running",
        "mcpDetail.status.start": "Start",
        "mcpDetail.status.starting": "Starting...",
        "mcpDetail.status.stop": "Stop",
        "mcpDetail.status.stopped": "Stopped",
        "mcpDetail.status.stopping": "Stopping...",
        "mcpDetail.table.req": "Req",
        "mcpDetail.tool.noParams": "no params",
        "mcpDetail.tool.paramsSummary": "{required} required, {total} total",
        "mcpDetail.tools.empty": "No tools registered.",
        "mcpDetail.tools.other": "Other",
        "mcpDetail.tools.startHint": "Start the MCP server to see registered tools.",
        "sessionDetail.activeSessions": "Active Sessions",
        "sessionDetail.connectedAt": "Connected {time}",
        "sessionDetail.connectedClients": "Connected MCP Clients",
        "sessionDetail.definitions": "Definitions",
        "sessionDetail.executionOrder": "Execution Order",
        "sessionDetail.forBlocks": "For Blocks",
        "sessionDetail.forOutputs": "For Outputs",
        "sessionDetail.headerDescription": "Active engine sessions. Each session corresponds to an open Markdown document.",
        "sessionDetail.innerDefinitions": "{count} inner definitions",
        "sessionDetail.iterations": "{count} iterations",
        "sessionDetail.loadingState": "Loading session state...",
        "sessionDetail.mcpClientCount": "{count} MCP clients",
        "sessionDetail.noSessions": "No sessions. Open a Markdown file and execute a plugin to create a session.",
        "sessionDetail.openFile": "Open File",
        "sessionDetail.outputs": "Outputs",
        "sessionDetail.sessionBadge": "Session",
        "sessionDetail.sessionCount": "{count} sessions",
        "sessionDetail.sessions": "Sessions",
        "sessionDetail.time.hoursAgo": "{count}h ago",
        "sessionDetail.time.justNow": "just now",
        "sessionDetail.time.minutesAgo": "{count}m ago",
        "sessionDetail.totalIterations": "Total Iterations",
        "workspace.action.addRoot": "Add Root",
        "workspace.action.close": "Close Workspace",
        "workspace.action.removeBookmark": "Delete bookmark",
        "workspace.action.removeFromWorkspace": "Remove from workspace",
        "workspace.action.save": "Save Workspace",
        "workspace.action.unstar": "Remove from favorites",
        "workspace.addRootDialog": "Add workspace root folder",
        "workspace.bookmarks": "Bookmarks",
        "workspace.empty.bookmarks": "No workspace bookmarks",
        "workspace.empty.folders": "No workspace root folders",
        "workspace.empty.starred": "No favorite files or folders",
        "workspace.notBound": "No workspace bound",
        "workspace.rootRemoved": "Root folder removed from workspace",
        "workspace.rootAdded": "Added root folder: {name}",
        "workspace.saved": "Workspace configuration saved",
        "workspace.stats.bookmarks": "Bookmarks",
        "workspace.stats.dirty": "Unsaved",
        "workspace.stats.folders": "Root folders",
        "workspace.stats.openFiles": "Open files",
        "workspace.stats.starred": "Favorites",
        "workspace.starred": "Favorites",
        "workspace.title": "Workspace Configuration",
        "sidecarDetail.action.debug": "Debug this capability",
        "sidecarDetail.action.openSettings": "Open Settings",
        "sidecarDetail.action.shutdown": "Shutdown",
        "sidecarDetail.action.start": "Start",
        "sidecarDetail.action.startToDebug": "Start sidecar to debug",
        "sidecarDetail.activeCapabilities": "Active Capabilities",
        "sidecarDetail.boundPlugins": "Bound Plugins",
        "sidecarDetail.calling": "Calling...",
        "sidecarDetail.capabilities.empty": "No matching capabilities.",
        "sidecarDetail.capabilities.examples": "Examples",
        "sidecarDetail.capabilities.filterPlaceholder": "Filter capabilities...",
        "sidecarDetail.capabilities.info": "Info",
        "sidecarDetail.capabilities.noParams": "No params",
        "sidecarDetail.capabilities.noSelection": "Select a capability on the left to inspect params and debug calls.",
        "sidecarDetail.capabilities.returns": "Returns",
        "sidecarDetail.capabilities.tabs": "Capability detail",
        "sidecarDetail.cloudConfigured": "Configured",
        "sidecarDetail.cloudNotConfigured": "Not Configured",
        "sidecarDetail.cloudNotConfiguredHint": "Cloud sidecar endpoint is not configured. Open Settings to set the endpoint.",
        "sidecarDetail.cloudSource": "Cloud Sidecar",
        "sidecarDetail.configuration": "Configuration",
        "sidecarDetail.debug": "Debug",
        "sidecarDetail.detailTitle": "Sidecar Detail",
        "sidecarDetail.enabledDescription": "Allow this Sidecar to auto-start and participate in runtime calls.",
        "sidecarDetail.fsEnabledDescription": "Built-in file-system Sidecar. Always enabled.",
        "sidecarDetail.invalidJson": "Invalid JSON in params",
        "sidecarDetail.notRunningHint": "Not running. It will start automatically when a bound plugin executes.",
        "sidecarDetail.overview": "Overview",
        "sidecarDetail.params": "Params",
        "sidecarDetail.protocol": "Protocol",
        "sidecarDetail.runtimeStatus": "Runtime Status",
        "sidecarDetail.send": "Send",
        "sidecarDetail.sourceInfo": "Source Info",
        "toc.collapseAll": "Collapse all",
        "toc.empty": "No outline available for the current document",
        "toc.expandAll": "Expand all",
        "toc.tooltip.content": "Content at line {line}",
        "toc.tooltip.for": "For at line {line}",
        "toc.tooltip.import": "Import at line {line}",
        "toc.tooltip.line": "Line {line}",
        "toc.tooltip.use": "Use at line {line}",
        "toolbar.theme.dark": "Switch to dark theme",
        "toolbar.theme.light": "Switch to light theme",
        "toolbar.toggleConfigSidebar": "Toggle config sidebar",
        "toolbar.toggleSidebar": "Toggle sidebar",
        "toolbar.view.editor": "Editor",
        "toolbar.view.preview": "Preview",
        "toolbar.view.split": "Split",
        "useBind.addBinding": "Add binding",
        "useBind.bindableCount": "{count} bindable",
        "useBind.dependencyBinding": "Dependency bindings",
        "useBind.importedDefinitions": "Imported definitions",
        "useBind.localDefinitions": "Local definitions",
        "useBind.noExternalRefs": "The source definition has no external $ref dependencies and does not need bindings",
        "useBind.pluginLabel": "Plugin: {name}",
        "useBind.selectPlaceholder": "Select...",
        "useBind.sourceDependencies": "Source definition dependencies",
        "useBind.sourceRefPlaceholder": "Source reference...",
        "useBind.targetDefinitionPlaceholder": "Target definition...",
        "contentBlockWrapper.configTitle": "Content instance config",
        "snapshot.confirmDelete": "Confirm delete",
        "snapshot.confirmDeleteMessage": "Delete this snapshot? This cannot be undone.",
        "snapshot.confirmRestore": "Confirm restore",
        "snapshot.confirmRestoreMessage": "This will overwrite the current file content and cannot be undone.",
        "snapshot.confirmRestoreTitle": "Confirm restore",
        "snapshot.delete": "Delete",
        "snapshot.deleting": "Deleting...",
        "snapshot.restore": "Restore",
        "snapshot.restoring": "Restoring...",
        "snapshot.status.deleteFailed": "Failed to delete snapshot",
        "snapshot.status.deleted": "Snapshot deleted",
        "snapshot.status.restored": "Snapshot restored",
        "snapshot.status.restoredWithPreSnapshot": "Snapshot restored. Showing the pre-restore snapshot content.",
        "meta.domain.document": "Document config",
        "meta.domain.module": "Module config",
        "meta.domain.output": "Output config",
        "meta.domain.snapshot": "Snapshot config",
        "meta.dragTitle": "Drag to move config panel",
        "meta.exports": "Export symbols (exports)",
        "meta.moving": "Moving",
        "meta.noDefinitions": "No definitions in the document",
        "meta.otherExports": "Other exports",
        "meta.config.external": "External storage",
        "meta.config.externalDesc": "Write the entire config to <doc>.magic-md/configs/ and keep only a __external stub in Markdown",
        "meta.config.inline": "Inline (default)",
        "meta.config.inlineDesc": "Keep the complete config in the Markdown config fence",
        "meta.config.storageMode": "Config storage mode (mode)",
        "meta.output.external": "External storage",
        "meta.output.externalDesc": "Write outputs to .magic-md/outputs/ and keep only summary stubs in the document",
        "meta.output.inline": "Inline (default)",
        "meta.output.inlineDesc": "Inline full outputs inside markdown fences",
        "meta.output.storageMode": "Storage mode (mode)",
        "meta.snapshot.enable": "Enable document snapshots",
        "meta.snapshot.keepCount": "Maximum snapshots",
        "meta.snapshot.keepDays": "Days to keep",
        "meta.snapshot.keepTagged": "Tagged snapshots are not cleaned up automatically",
        "meta.snapshot.mode.manual": "Manual only",
        "meta.snapshot.mode.manualDesc": "Create snapshots only from buttons or commands",
        "meta.snapshot.mode.off": "Off",
        "meta.snapshot.mode.offDesc": "Disable snapshots for the whole document",
        "meta.snapshot.mode.onSave": "Auto on save",
        "meta.snapshot.mode.onSaveDesc": "Create snapshots automatically when saving the document; manual snapshots still work",
        "meta.snapshot.retention": "Retention (retention)",
        "meta.snapshot.retentionHint": "Snapshots always store the full file content. If retention is not declared, automatic cleanup is disabled.",
        "meta.snapshot.triggerMode": "Trigger mode (mode)",
        "meta.symbol.content": "content",
        "meta.symbol.contentTemplate": "content/template",
        "debug.analyzing": "Analyzing...",
        "debug.diagnostics": "Diagnostics ({count})",
        "debug.empty": "Run the document to select execution units in the global dependency graph",
        "debug.executionOrder": "Execution order",
        "debug.globalDependencyGraph": "Global dependency graph",
        "debug.graphAria": "Dependency graph. Click an execution unit to view debug details.",
        "debug.legend": "Legend",
        "debug.legend.content": "content block",
        "debug.legend.for": "for loop",
        "debug.legend.import": "import module",
        "debug.noUnits": "No execution units",
        "debug.position": "{index} / {total}",
        "debug.viewUnitDetails": "View debug details for {id}",
        "scope.maxDepthExceeded": "Maximum nested depth exceeded ({max})",
        "push.confirmPairing": "Confirm pairing",
        "push.connectedDevice": "Connected device",
        "push.connecting": "Connecting...",
        "push.continueScanning": "Still scanning...",
        "push.disconnect": "Disconnect",
        "push.enterPairingCode": "Enter the pairing code shown in Play",
        "push.error.cannotConnect": "Cannot connect to Play device",
        "push.noDevicesFound": "No Play devices found",
        "push.paired": "Paired",
        "push.playDevice": "Play device",
        "push.push": "Push",
        "push.pushCurrentDocument": "Push current document",
        "push.realtimeSyncing": "Realtime syncing",
        "push.rescan": "Rescan",
        "push.scanHint": "Tap \"Sync Content\" in Play, then scan",
        "push.searchingDevices": "Searching for devices...",
        "push.searchingLan": "Searching local network devices...",
        "push.sending": "Sending",
        "push.sent": "Pushed",
        "push.startRealtimeSync": "Start realtime sync",
        "push.status.connectedTo": "Connected to {name}",
        "push.status.connectionFailed": "Device connection failed",
        "push.status.disconnected": "Device disconnected",
        "push.status.disconnectFailed": "Failed to disconnect",
        "push.status.documentPushed": "Document pushed",
        "push.status.pushFailed": "Push failed",
        "push.status.startSyncFailed": "Failed to start sync",
        "push.status.stopSyncFailed": "Failed to stop sync",
        "push.status.syncStarted": "Sync started",
        "push.status.syncStopped": "Sync stopped",
        "push.stopRealtimeSync": "Stop realtime sync",
        "push.sync": "Sync",
        "push.syncing": "Syncing",
        "push.toPlay": "Push to Play",
        "push.verifying": "Verifying...",
        "assetRefs.copyCode": "Copy code content",
        "assetRefs.copyFailed": "Copy failed",
        "assetRefs.copySuccess": "Copied",
        "assetRefs.unsafePath": "Unsafe asset path: {ref}",
        "publish.error.defaultDocumentOutDir": "Cannot resolve the default publish directory for the current document",
        "publish.error.defaultFolderOutDir": "Cannot resolve the default publish directory for the current folder",
        "publish.error.previousStartStale": "The previous publish start did not complete. Republish is allowed.",
        "publish.log.folderCancelled": "Folder publish cancelled: {path}",
        "publish.log.folderCompleted": "Folder publish completed ({path}): {built} pages built, {cached} pages cached, {failed} pages failed",
        "publish.log.folderFailed": "Folder publish failed ({path}): {message}",
        "publish.log.folderStart": "Starting folder publish: {path}",
        "publish.log.folderStartFailed": "Folder publish failed to start: {message}",
        "publish.log.randomPort": "random",
        "publish.log.siteCancelled": "Site publish cancelled",
        "publish.log.siteCompleted": "Site publish completed: {built} pages built, {cached} pages cached, {failed} pages failed",
        "publish.log.siteCompletedTask": "Site publish completed (taskId: {taskId})",
        "publish.log.siteFailed": "Site publish failed: {message}",
        "publish.log.siteFailedTask": "Site publish failed (taskId: {taskId}): {message}",
        "publish.log.siteServerStart": "Starting site server: {path} (port {port})",
        "publish.log.siteServerStarted": "Site server started: {url}",
        "publish.log.siteServerStartFailed": "Site server failed to start: {message}",
        "publish.log.siteServerStopped": "Site server stopped",
        "publish.log.siteStart": "Starting site publish: {path}",
        "publish.log.siteStartFailed": "Site publish failed to start: {message}",
        "publish.log.taskCompleted": "Task completed (taskId: {taskId})",
        "publish.log.taskFailed": "Task failed (taskId: {taskId}): {message}",
        "publish.log.taskStarted": "Task started (taskId: {taskId})",
        "publish.logPrefix": "Publish",
        "publish.progress.cancelled": "Cancelled",
        "publish.progress.completed": "Publish completed",
        "publish.progress.folderCompleted": "Folder publish completed",
        "publish.progress.pendingExpired": "Publish start expired",
        "publish.progress.siteCompleted": "Site publish completed",
        "publish.progress.startingDocument": "Starting publish...",
        "publish.progress.startingFolder": "Starting folder publish...",
        "publish.progress.startingSite": "Starting site publish...",
        "publish.status.documentRunning": "This document is already publishing",
        "publish.status.folderRunning": "This folder is already publishing",
        "publish.status.startFailedCheckStatus": "Publish failed to start. Check publish.status.json.",
        "publish.status.started": "Publish started. Check the publish package for status.",
        "engineStub.configureEngine": "Engine is not connected. Configure the Engine connection in Settings.",
        "engineStub.explainCannotExplain": "Cannot explain {targetId}",
        "engineStub.explainUnavailable": "Engine is not connected, so explain results cannot be generated.",
        "engineStub.noRuntimeSession": "There is no available runtime session.",
        "engineStub.offlineTitle": "Engine not connected",
        "engineConnector.cancelled": "Connection cancelled",
        "engineConnector.cannotConnectEndpoint": "Cannot connect to Engine: {endpoint}",
        "engineConnector.connectingCloud": "Connecting to cloud Engine...",
        "engineConnector.connectingEndpoint": "Connecting Engine {endpoint}...",
        "engineConnector.disconnected": "Engine connection disconnected",
        "engineConnector.endpointRequired": "Set the Engine address first",
        "engineConnector.preparing": "Preparing connection...",
        "engineConnector.statusUnavailable": "Cannot get Engine status",
        "settingsService.targetWriteUnsupported": "The current connection does not support writing this settings target",
        "externalOpeners.openWithCursor": "Open with Cursor",
        "externalOpeners.openWithSystem": "Open with system default app",
        "externalOpeners.openWithVSCode": "Open with VSCode",
        "externalOpeners.openWithZed": "Open with Zed",
        "externalOpeners.revealInFolder": "Reveal in Folder",
        "explorerReveal.located": "Located in Explorer",
        "previewWidth.customWithPx": "Custom {width}px",
        "publishPreview.artifactMissing": "Publish artifact not found. Publish this document first.",
        "publishPreview.markdownOnly": "Only Markdown documents support publish preview",
        "publishPreview.opened": "Publish preview opened",
        "scopeVariables.loopIndex": "Current iteration index of \"{each}\" (starting at 0)",
        "scopeVariables.loopVariable": "Loop variable \"{each}\" over {source}",
        "scopeVariables.templateInput": "Template input",
        "scopeVariables.templateParamFromWith": "Template parameter passed through with={}",
        "previewLogic.exportHint.current": "Current exports: {preview}{suffix}",
        "previewLogic.exportHint.more": " and {count} more",
        "previewLogic.filter.excludeHint": "\"{name}\" is excluded by exclude. Remove it from exclude or use a visible symbol.",
        "previewLogic.filter.pickEmptyHint": "This symbol is not in the pick list. Add it to pick or use a visible symbol.",
        "previewLogic.filter.pickVisibleHint": "Currently visible in pick: {preview}{suffix}",
        "previewLogic.issue.importDocumentDisabled.hint": "If you only want to render an exported symbol, use ::render[{targetId}/symbol].",
        "previewLogic.issue.importDocumentDisabled.message": "::render[{targetId}] needs document=\"true\" on the matching ::import to render the whole imported document.",
        "previewLogic.issue.importDocumentDisabled.title": "Imported document is not enabled",
        "previewLogic.issue.importDocumentNotResolved.hint": "Run the matching import to show the whole imported document.",
        "previewLogic.issue.importDocumentNotResolved.message": "::render[{targetId}] needs ::import ns=\"{targetId}\" to run first and generate a document snapshot.",
        "previewLogic.issue.importDocumentNotResolved.title": "Imported document snapshot has not been generated",
        "previewLogic.issue.importError.hint": "Fix the import source file or rerun the import.",
        "previewLogic.issue.importError.message": "::import ns=\"{namespace}\" failed: {message}",
        "previewLogic.issue.importError.title": "Import execution failed",
        "previewLogic.issue.importNotResolved.hint": "Run the matching import to restore renderable symbols and outputs.",
        "previewLogic.issue.importNotResolved.message": "::render[{targetId}] needs ::import ns=\"{namespace}\" to resolve first.",
        "previewLogic.issue.importNotResolved.title": "Import has not been resolved",
        "previewLogic.issue.importSymbolFiltered.message": "::render[{targetId}] is filtered by the {filter} rule on ::import ns=\"{namespace}\"; this import will not export that symbol.",
        "previewLogic.issue.importSymbolFiltered.title": "Imported symbol is filtered",
        "previewLogic.issue.importSymbolMissing.hint": "Check ::meta[module].exports in the source document, or use the correct \"{publicName}\" name.",
        "previewLogic.issue.importSymbolMissing.message": "::render[{targetId}] does not exist in the exports of ::import ns=\"{namespace}\".",
        "previewLogic.issue.importSymbolMissing.title": "Imported symbol is not exported",
        "previewLogic.issue.importSymbolNotRestored.hint": "Rerun the matching import, or check whether the import cache is stale.",
        "previewLogic.issue.importSymbolNotRestored.message": "::render[{targetId}] is registered in the import cache, but Preview did not restore a renderable instance.",
        "previewLogic.issue.importSymbolNotRestored.title": "Imported symbol was not restored",
        "previewLogic.issue.inlineImportDocument.hint": "Move render to its own line, or render a specific exported symbol.",
        "previewLogic.issue.inlineImportDocument.message": "::render[{targetId}] must be on its own line when rendering a whole imported document.",
        "previewLogic.issue.inlineImportDocument.title": "Imported documents only support block rendering",
        "previewLogic.issue.unknownDefinition.hint": "Check the ID spelling, or declare the matching ::define / ::content / ::for first.",
        "previewLogic.issue.unknownDefinition.message": "::render[{targetId}] did not find a definition, content, for block, or imported document with the same name.",
        "previewLogic.issue.unknownDefinition.title": "Render target does not exist",
        "previewLogic.issue.unknownNamespace.hint": "Add ::import{from=\"...\" ns=\"{namespace}\"} first, or use an existing namespace.",
        "previewLogic.issue.unknownNamespace.message": "::render[{targetId}] references an imported namespace \"{namespace}\" that has not been imported.",
        "previewLogic.issue.unknownNamespace.title": "Namespace is not imported",
        "syntax.summary.bindItems": "bind {count} items",
        "syntax.summary.completedPartial": "Completed {succeeded}/{total}",
        "syntax.summary.concurrency": "concurrency {count}",
        "syntax.summary.configItems": "{count} config items",
        "syntax.summary.configStorageMode": "Config default: {mode}",
        "syntax.summary.contentBlock": "Content block",
        "syntax.summary.contentRunning": "Content running",
        "syntax.summary.domainConfigItems": "{domain} config: {count} items",
        "syntax.summary.executionResult": "Execution result",
        "syntax.summary.exports": "Exports {count} symbols",
        "syntax.summary.generated": "Generated {count} items",
        "syntax.summary.generatedPartial": "Generated {succeeded}/{total} items",
        "syntax.summary.importAll": "Import all symbols",
        "syntax.summary.importAllExcept": "Import all except {count}",
        "syntax.summary.importPicked": "Import {count} symbols",
        "syntax.summary.importResolved": "Resolved {count} symbols",
        "syntax.summary.importResolving": "Resolving import",
        "syntax.summary.inProgress": "In progress {current}/{total}",
        "syntax.summary.instantiatedFrom": "Instantiated from {source}",
        "syntax.summary.instantiating": "Instantiating",
        "syntax.summary.iterate": "Iterate {value}",
        "syntax.summary.iterationsCompleted": "Completed {count} iterations",
        "syntax.summary.jsonError": "Warning: JSON error",
        "syntax.summary.lines": "{count} lines",
        "syntax.summary.moduleConfigItems": "Module config: {count} items",
        "syntax.summary.patchItems": "patch {count} items",
        "syntax.summary.publishTarget": "Publish target {target}",
        "syntax.summary.query": "Query {value}",
        "syntax.summary.read": "Read {value}",
        "syntax.summary.refs": "{count} references",
        "syntax.summary.renameItems": "Rename {count}",
        "syntax.summary.request": "Request {value}",
        "syntax.summary.runPlugin": "Run {pluginName}",
        "syntax.summary.runningWithSummary": "{summary} · running",
        "syntax.summary.template": "Template",
        "syntax.summary.templateRunning": "Template running",
        "syntax.summary.use": "Use {value}",
        "syntax.summary.withItems": "with {count} items",
        "syntax.widget.comment.default": "comment",
        "syntax.widget.comment.editRaw": "Click to edit the raw comment",
        "syntax.widget.content.clearError": "Clear content error ({id})",
        "syntax.widget.content.editInputs": "Edit content inputs ({id})",
        "syntax.widget.content.hideInlineRender": "Hide inline render ({id})",
        "syntax.widget.content.kind.content": "content",
        "syntax.widget.content.kind.template": "template",
        "syntax.widget.content.run": "Run content ({id})",
        "syntax.widget.content.showInlineRender": "Show inline render ({id})",
        "syntax.widget.content.stop": "Stop content ({id})",
        "syntax.widget.define.clearError": "Clear execution error ({id})",
        "syntax.widget.define.configure": "Configure \"{pluginName}\" ({id})",
        "syntax.widget.define.editTemplateInputs": "Edit template inputs ({id})",
        "syntax.widget.define.hideInlineRender": "Hide inline render for \"{pluginName}\" ({id})",
        "syntax.widget.define.pin": "Pin \"{pluginName}\" ({id})",
        "syntax.widget.define.run": "Run \"{pluginName}\" ({id})",
        "syntax.widget.define.showInlineRender": "Show inline render for \"{pluginName}\" ({id})",
        "syntax.widget.define.stop": "Stop \"{pluginName}\" ({id})",
        "syntax.widget.drag.move": "Drag to move",
        "syntax.widget.drag.moveNamed": "Drag to move {label}",
        "syntax.widget.for.clearError": "Clear for-loop error ({id})",
        "syntax.widget.for.editInputs": "Edit for inputs ({id})",
        "syntax.widget.for.hideInlineRender": "Hide inline render ({id})",
        "syntax.widget.for.run": "Run for loop ({id})",
        "syntax.widget.for.showInlineRender": "Show inline render ({id})",
        "syntax.widget.for.stop": "Stop for loop ({id})",
        "syntax.widget.import.clearError": "Clear import error ({namespace})",
        "syntax.widget.import.run": "Run import \"{namespace}\" from \"{source}\"",
        "syntax.widget.import.stop": "Stop import \"{namespace}\"",
        "syntax.widget.meta.configure": "Configure {domain}",
        "syntax.widget.meta.snapshotDocument": "Snapshot the whole document now",
        "syntax.widget.use.clearError": "Clear use error ({id})",
        "syntax.widget.use.configurePlugin": "Configure \"{pluginName}\" ({id})",
        "syntax.widget.use.configureSource": "Configure {sourceLabel} ({id})",
        "syntax.widget.use.contentInstance": "content instance",
        "syntax.widget.use.editInputs": "Edit use inputs ({id})",
        "syntax.widget.use.hideInlineRender": "Hide inline render ({id})",
        "syntax.widget.use.pin": "Pin \"{pluginName}\" ({id})",
        "syntax.widget.use.run": "Run {sourceLabel} ({id})",
        "syntax.widget.use.showInlineRender": "Show inline render ({id})",
        "syntax.widget.use.stop": "Stop {sourceLabel} ({id})",
        "syntax.widget.use.useInstance": "use instance",
        "completion.contentBody": "Content body",
        "completion.contentDefinition": "Content definition",
        "completion.definition": "Definition",
        "completion.definitionWithPlugin": "Definition: {pluginName}",
        "completion.documentAssetsPackage": "Document assets package",
        "completion.forLoop": "For loop",
        "completion.forOutput": "For output",
        "completion.useInstance": "Use instance",
        "completion.useOutput": "Use output",
        "intelligence.findReferences": "Find references ({count})",
        "intelligence.jumpTo": "Jump to {id}",
        "intelligence.predecessors": "Predecessors of {id}",
        "intelligence.preferred": "Preferred",
        "intelligence.rename": "Rename {id}",
        "intelligence.run": "Run {id}",
        "intelligence.successors": "Successors of {id}",
        "refResolution.assetMissing": "Asset does not exist",
        "refResolution.assetPathInvalid": "Asset path is invalid",
        "refResolution.assetPathMissing": "Asset does not exist: {path}",
        "refResolution.contentMissing": "Content does not exist",
        "refResolution.definitionMissing": "Definition does not exist",
        "refResolution.error": "Execution failed",
        "refResolution.loopVariable": "Loop variable",
        "refResolution.loopVariablePath": "Loop variable path: {path}",
        "refResolution.pathMissing": "Path does not exist: {path}",
        "refResolution.pending": "Not run",
        "refResolution.running": "Running...",
        "refResolution.scopeVariable": "Scope variable",
        "refResolution.scopeVariablePath": "Scope variable path: {path}",
        "refResolution.unitMissing": "unit does not exist",
        "refResolution.variableMissing": "Variable does not exist",
        "refResolution.variablePathMissing": "Variable path does not exist: {path}",
        "syntax.fence.jsonParseFailed": "JSON parse failed: {message}",
        "welcome.commandPaletteHint": "Press ⌘⇧P to open the Command Palette",
        "welcome.recentWorkspaces": "Recent Workspaces",
        "welcome.removeRecent": "Remove from recent items",
        "welcome.removeRecentNamed": "Remove {name} from recent items",
        "welcome.subtitle": "A workbench for executable documents",
        "execution.circularDependency": "Circular dependency",
        "sessionSync.conflictCopyTitle": "{title} (conflict copy)",
        "sessionSync.conflictRecovered": "{title} changed in another client. Your local edits were preserved as {copyTitle}."
    },
    "engineIntelligence": {
        "completion.closeFor.detail": "Close for loop block",
        "completion.bodyPath": "{name} · .body",
        "completion.chooseImportedSymbol.documentation": "Type {namespace}/<ID> to choose an imported symbol, then continue with `.output.` or `.body` based on its type.",
        "completion.collapsedDefault.detail": "Collapsed by default",
        "completion.collapsedDefault.documentation": "Show only the render title until the user expands it.",
        "completion.compatAlias.documentation": "Compatibility alias equivalent to \"{target}\".",
        "completion.configKey": "config key",
        "completion.configPatch.detail": "Config patch",
        "completion.configPatch.documentation": "Shallow merges into the source definition config.",
        "completion.configMetadata.detail": "Config metadata",
        "completion.configMetadata.documentation": "Declares document-level configuration parameters.",
        "completion.content.detail": "Define reusable content",
        "completion.content.documentation": "Insert a content definition block for reusable Markdown content.\n\n```\n::content[contentId]\nTemplate content...\n::\n```",
        "completion.contentBody": "Content body",
        "completion.contentDefinition": "Content definition",
        "completion.contentDefinition.documentationShort": "Content definition \"{id}\".",
        "completion.contentDefinitionFrom": "Content definition (from {source})",
        "completion.contentMember": "Content member · {kind}",
        "completion.contentTemplate": "Content template",
        "completion.contentTemplate.detail": "Define content template",
        "completion.contentTemplateAttr.documentation": "Marks this content block as a template that can receive external data via $ref{input/field}.",
        "completion.currentDirectory": "Current directory",
        "completion.currentDirectory.documentation": "Import from the current document directory",
        "completion.define.detail": "Define a plugin instance",
        "completion.define.documentation": "Insert a `::define` block with a config fence.\n\n```\n::define[id]{plugin=\"plugin-name\"}\n```config\n{}\n```\n::\n```",
        "completion.define.insertDetail": "Insert definition block",
        "completion.defineOutputAttr.documentation": "Controls output storage for this definition. `external` writes output to external files; `inline` keeps it inline and overrides document-level ::meta[output].",
        "completion.defineTemplateAttr.documentation": "Marks this definition as a template that can receive parameters in config via $ref{input/field}.",
        "completion.dependencyRebind.detail": "Dependency rebind",
        "completion.dependencyRebind.documentation": "Replaces source IDs inside $ref{} with new IDs.",
        "completion.dependencyRebindTarget.detail": "Dependency rebind target",
        "completion.directoryMatch": "Directory match",
        "completion.documentAssets.detail": "Document Assets Package",
        "completion.documentAssets.documentation": "Reference the assets package next to the current Markdown document: $ref{assets/path/to/file}.",
        "completion.disableSnapshots.detail": "Disable snapshots",
        "completion.enableSnapshots.detail": "Enable snapshots",
        "completion.endFor.detail": "End for loop",
        "completion.expandedDefault.detail": "Expanded by default",
        "completion.expandedDefault.documentation": "Expand this block render when the document opens.",
        "completion.exportContentDefinition.documentation": "Export content definition \"{id}\".",
        "completion.exportPluginDefinition.documentation": "Export plugin definition \"{id}\".",
        "completion.exportUse.documentation": "Export the materialized symbol from ::use[{id}].",
        "completion.exportUseWithPublicName.documentation": "Export the materialized symbol from ::use[{id}] with a public name (format: localName:publicName).",
        "completion.exportWithPublicName.documentation": "Export \"{id}\" with a public name (format: localName:publicName).",
        "completion.exportedSymbols.detail": "Exported symbols",
        "completion.exportedSymbols.documentation": "Declares exported symbols for this module, for example `[\"id1\", \"id2:alias\"]`.",
        "completion.externalOutput.detail": "External output",
        "completion.externalOutput.documentation": "Store all output data in `.magic-md/outputs/` and keep only lightweight references in the document. Useful for documents with large output data.",
        "completion.for.detail": "Loop over a data source",
        "completion.for.documentation": "Insert a `::for` block to iterate over an output array from a definition.\n\n```\n::for[loopId]{each=\"item\" of=\"$ref{sourceId.output.items}\"}\n...\n::endfor\n```",
        "completion.for.insertDetail": "Loop over data source",
        "completion.forConcurrency.documentation": "Number of concurrent executions.",
        "completion.forEach.documentation": "Loop variable name, such as item, repo, or row.",
        "completion.forLimit.documentation": "Maximum number of iterations.",
        "completion.forLoop": "For loop",
        "completion.forOf.documentation": "Data source, using $ref{id.output.path} to reference an array.",
        "completion.forOffset.documentation": "Skip the first N items.",
        "completion.forTemplate": "For template",
        "completion.forTemplateAttr.documentation": "Marks this loop as a template that can receive parameters via $ref{input/field}.",
        "completion.from": "From {source}",
        "completion.fromSource": "<- {source}",
        "completion.getContentOutput.documentation": "Get execution output for content definition \"{id}\".",
        "completion.getMarkdownBody.documentation": "Get the Markdown body text for content definition \"{id}\".",
        "completion.higherParentDirectory": "Higher parent directory",
        "completion.higherParentDirectory.documentation": "Navigate to a higher parent directory",
        "completion.import.detail": "Import symbols from another module",
        "completion.import.documentation": "Insert an `::import` directive to import definitions from another file.\n\n```\n::import{from=\"./file.md\" ns=\"alias\"}\n```",
        "completion.importDocument.documentation": "Cache the imported document snapshot so ::render[ns]:: can render the entire imported document.",
        "completion.importExternal.detail": "Import external module",
        "completion.importExclude.documentation": "Exclude the specified symbols (comma-separated).",
        "completion.importFrom.documentation": "Source file path (relative path).",
        "completion.importNamespace.documentation": "Namespace, inferred from the file name by default.",
        "completion.importPathDirectory": "Import path directory",
        "completion.importPick.documentation": "Only import the specified symbols (comma-separated).",
        "completion.importRename.documentation": "Rename symbols using old:new format (comma-separated).",
        "completion.importableMarkdownFile": "Importable Markdown file",
        "completion.importedAssets.documentation": "Reference assets from imported namespace `{namespace}`: $ref{{ref}}.",
        "completion.importedBody": "{name} (imported) · .body",
        "completion.importedContentDefinition.documentation": "Imported content definition \"{id}\".",
        "completion.importedDefinition.documentation": "Imported definition \"{id}\".",
        "completion.importedDocument": "Imported document · {source}",
        "completion.importedDocumentFrom": "Imported document (from {source})",
        "completion.importedFrom": "Imported from {source}",
        "completion.importedOutput": "{name} (imported) · .output",
        "completion.insertRef.documentation": "Insert $ref{{ref}}",
        "completion.localDefinition.documentation": "Local definition \"{id}\".",
        "completion.loopItem.documentation": "Item variable for loop `{forId}`.",
        "completion.loopScoped": "{name} · loop {scope}",
        "completion.loopField.detail": "Loop variable field inferred from samples",
        "completion.loopIndex.detail": "Loop index (0-based)",
        "completion.loopIndex.documentation": "Current index for loop `{forId}`.",
        "completion.loopVariableFor": "Loop variable · {forId}",
        "completion.loopVariable.detail": "Loop variable (current item)",
        "completion.loopVariableReference.detail": "Loop variable reference",
        "completion.markdownFile": "Markdown file",
        "completion.markdownFileMatch": "Markdown file match",
        "completion.metaConfig.detail": "Document config",
        "completion.metaConfig.documentation": "Insert a `::meta[config]` block to declare document-level config parameters.",
        "completion.metaModule.detail": "Declare module metadata",
        "completion.metaModule.documentation": "Insert a `::meta[module]` block to declare exported symbols.\n\n```\n::meta[module]\n```config\n{ \"exports\": [\"symbol1\", \"symbol2\"] }\n```\n::\n```",
        "completion.metaOutput.detail": "Externalize output",
        "completion.metaOutput.documentation": "Insert a `::meta[output]` block to externalize document output data into `.magic-md/outputs/`. Useful for large outputs such as SQL query results or API responses.",
        "completion.metaSnapshot.detail": "Version snapshot policy",
        "completion.metaSnapshot.documentation": "Insert a `::meta[snapshot]` block to control document-level snapshot behavior.\n\n- `mode`: `manual`, `on-save`, or `off`\n- `retention`: retention policy (`keepCount` / `keepDays`)",
        "completion.moduleMetadata.detail": "Module metadata",
        "completion.moduleMetadata.documentation": "Declares exported symbols and namespaces for the module.",
        "completion.namedTemplate": "{name} · Template",
        "completion.namespaceFrom": "Namespace {namespace} (from {source})",
        "completion.namespaceFromSource": "Namespace (from {source})",
        "completion.option": "{name} option",
        "completion.optional.detail": "Optional",
        "completion.outputAttr.documentation": "Output storage mode overriding document-level ::meta[output]: external=file-backed, inline=inline.",
        "completion.outputFieldsPending.detail": "Output fields become available after running",
        "completion.outputFieldsPending.documentation": "There is no runtime output and no static outputSchema available.",
        "completion.outputPath": "{name} · .output",
        "completion.outputPolicy.detail": "Output storage policy",
        "completion.outputPolicy.documentation": "Declares how document output is stored. Set `{ \"mode\": \"external\" }` to externalize output data into `.magic-md/outputs/` and reduce document size.",
        "completion.outputStorageMode.detail": "Output storage mode",
        "completion.outputStorageMode.documentation": "Controls output storage. `\"external\"` moves output into separate files and reduces document size.",
        "completion.parentDirectory": "Parent directory",
        "completion.parentDirectory.documentation": "Import from the parent directory",
        "completion.parentLoopVariable.documentation": "Reference the parent loop `{forId}` item variable, such as `{example}`.",
        "completion.parameterInjection.detail": "Parameter injection (advanced)",
        "completion.parameterInjection.documentation": "Injects additional parameters into the source definition.",
        "completion.rawMarkdown.detail": "Raw Markdown",
        "completion.rawMarkdownCompatibility.detail": "Raw Markdown (compatibility alias)",
        "completion.render.insertDetail": "Insert render tag",
        "completion.renderDefinition.detail": "Render a definition output",
        "completion.renderDefinition.documentation": "Insert a `::render[id]::` tag to display the rendered result for a definition.",
        "completion.renderLoopOutput.documentation": "Render output from loop \"{id}\".",
        "completion.refEmpty.detail": "Reference another definition or content block",
        "completion.refEmpty.documentation": "Insert an empty $ref{} reference, then continue with an ID, .output., or .body.",
        "completion.referenceContentBody.documentation": "Reference content definition \"{id}\"; continue with `.body` to access raw Markdown.",
        "completion.referenceContentMemberOutput.documentation": "Reference content package member \"{id}\"; continue with `.output.` to access member output fields.",
        "completion.referenceImportedContentBody.documentation": "Reference imported content \"{id}\"; continue with `.body` to access raw Markdown.",
        "completion.referenceImportedOutput.documentation": "Reference imported \"{id}\"; continue with `.output.` to access output fields.",
        "completion.referenceLoopOutput.documentation": "Reference execution output from loop \"{id}\"; continue with \".output.\" to access iteration results.",
        "completion.referenceOutput.documentation": "Reference \"{id}\" ({source}); continue with `.output.` to access output fields.",
        "completion.referenceUseOutput.documentation": "Reference ::use instance \"{id}\"; continue with `.output.` to access output fields.",
        "completion.required.detail": "Required",
        "completion.scopedOutput.detail": "Scoped output",
        "completion.selectUnit.documentation": "Select unit `{id}` and insert `{ref}` as an identity reference.",
        "completion.snapshotDisabled.documentation": "Disable document-level snapshots.",
        "completion.snapshotEnabled.documentation": "Master switch. When false, all snapshots are disabled for this document.",
        "completion.snapshotEnabled.detail": "Enabled",
        "completion.snapshotManual.detail": "Manual only",
        "completion.snapshotManual.documentation": "Create snapshots only when manually triggered.",
        "completion.snapshotMode.detail": "Trigger mode",
        "completion.snapshotMode.documentation": "Controls when snapshots are created: `manual`, `on-save`, or `off`.",
        "completion.snapshotOff.detail": "Off",
        "completion.snapshotOnSave.detail": "On save + manual",
        "completion.snapshotOnSave.documentation": "Create a snapshot each time the document is saved, while still allowing manual snapshots.",
        "completion.snapshotRetention.detail": "Retention policy",
        "completion.snapshotRetention.documentation": "Snapshot retention policy. `{ \"keepCount\": 50 }` keeps the latest 50 snapshots; `{ \"keepDays\": 30 }` keeps the latest 30 days.",
        "completion.staticPath": "{type} · static",
        "completion.symbolInNamespace.documentation": "\"{symbol}\" in namespace \"{namespace}\".",
        "completion.templateParameter.detail": "Template parameter",
        "completion.templateParameter.documentation": "Template parameter $ref{input/{param}}",
        "completion.templateParameters.detail": "Template parameters ({params})",
        "completion.templateParameters.documentation": "Injects template parameter values and replaces $ref{input/xxx}.",
        "completion.templateParametersList.documentation": "Template parameters: {params}",
        "completion.templateTarget.documentation": "{kind} \"{id}\" is a template and does not execute directly. ::render[] only shows a template placeholder; instantiate it with ::use before rendering.",
        "completion.typeImportedReference.documentation": "Type {namespace}/<ID> to reference an imported definition.",
        "completion.unitIdentity.detail": "Unit identity reference",
        "completion.unitIdentity.documentation": "Reference the identity of a controllable unit with $ref{unit/<unitId>}. Used by fields such as control plugin unitId.",
        "completion.use.detail": "Reference and configure an instance",
        "completion.use.documentation": "Insert a `::use` block to reference a definition and override its config.\n\n```\n::use[instanceId]{from=\"sourceId\"}\n```config\n{ \"key\": \"override\" }\n```\n::\n```",
        "completion.use.instanceDetail": "Reference and configure instance",
        "completion.useTemplateFrom": "Use template · <- {source}",
        "completion.useOutputAsLoopSource.documentation": "Use the output of \"{id}\" as the loop data source.",
        "completion.withAlias": "{name} · with alias",
        "diagnostic.assetsFileMissing": "Assets file does not exist: {path}",
        "diagnostic.changeTo": "Change to \"{suggestion}\"",
        "diagnostic.circularDependency": "Circular dependency detected: {path}",
        "diagnostic.duplicateDefinition": "Duplicate definition ID \"{id}\" (first defined at line {line})",
        "diagnostic.importMissingFrom": "::import is missing required attribute from=\"\"",
        "diagnostic.importedNamespaceMissing": "Imported namespace does not exist: {namespace}",
        "diagnostic.invalidAssetPath": "Invalid assets reference path: \"{path}\"",
        "diagnostic.invalidJson": "Invalid JSON",
        "diagnostic.invalidJsonConfig": "Invalid JSON in config block: {message}",
        "diagnostic.invalidOutputAttr": "Invalid output attribute value \"{value}\" - only \"external\" or \"inline\" is supported",
        "diagnostic.metaOutputInvalidMode": "::meta[output] mode \"{mode}\" is invalid - currently only \"external\" is supported",
        "diagnostic.metaOutputMissingMode": "::meta[output] requires a \"mode\" field, for example { \"mode\": \"external\" }",
        "diagnostic.missingConfig": "::define block \"{id}\" has no config block",
        "diagnostic.missingTemplateParam": "::{kind}[{id}] is missing required template parameter \"{param}\" (from {source})",
        "diagnostic.refPathNotFound": "$ref path \"{path}\" not found in output of \"{id}\"",
        "diagnostic.unclosedContent": "Unclosed content definition block \"{id}\" - missing closing \"::\" line",
        "diagnostic.unclosedDefine": "Unclosed ::define block \"{id}\" — missing closing \"::\" line",
        "diagnostic.unclosedMeta": "Unclosed ::meta block - missing closing \"::\" line",
        "diagnostic.unclosedUse": "Unclosed ::use block \"{id}\" - missing closing \"::\" line",
        "diagnostic.unknownDefinition": "Unknown definition \"{id}\"",
        "diagnostic.unknownDefinitionSuggestion": "Unknown definition \"{id}\" — did you mean \"{suggestion}\"?",
        "diagnostic.unknownPlugin": "Unknown plugin \"{plugin}\"",
        "diagnostic.unknownPluginSuggestion": "Unknown plugin \"{plugin}\" — did you mean \"{suggestion}\"?",
        "hover.config": "Config",
        "hover.configOverrides": "Config overrides",
        "hover.contentDefinitionNotFound": "Content definition not found",
        "hover.contentLines": "content lines",
        "hover.contentNoOutput": "Content has no output",
        "hover.definitionDoesNotExist": "Definition does not exist",
        "hover.documentRenderEnabled": "document: `::render[ns]::` enabled",
        "hover.executed": "Executed",
        "hover.executionOutputSection": "Execution output section",
        "hover.exports": "Exports",
        "hover.failed": "failed",
        "hover.filePath": "File path",
        "hover.from": "From",
        "hover.importedDocument": "Imported document",
        "hover.importedDocumentSnapshotMissing": "Imported document snapshot has not been generated yet.",
        "hover.importedFrom": "Imported from",
        "hover.importedNamespaceMissing": "Imported namespace does not exist",
        "hover.innerOutputs": "inner outputs",
        "hover.invalidAssetPath": "Invalid asset path",
        "hover.iterations": "iterations",
        "hover.iterationsTotal": "iterations total",
        "hover.jsonConfigSection": "JSON config section",
        "hover.lines": "Lines",
        "hover.notRun": "Not run",
        "hover.output": "Output",
        "hover.outputManualEdits": "Manual edits are overwritten on the next run",
        "hover.pathNotFound": "Path not found",
        "hover.requiresDocumentImport": "Requires `document=\"true\"` on the corresponding `::import`.",
        "hover.requiresDocumentImportRun": "Requires `document=\"true\"` and a completed import run to resolve assets for this namespace.",
        "hover.serializationError": "(serialization error)",
        "hover.sourceUnresolved": "Source has not been resolved or materialized yet.",
        "hover.targetNotFound": "Target not found",
        "hover.unknownPlugin": "Unknown plugin",
        "symbols.configOverride": "Config override",
        "symbols.executionOutput": "Execution output",
        "symbols.jsonConfig": "JSON config",
        "symbols.metadataConfig": "Metadata config",
        "template.default": "Default",
        "template.description": "Description",
        "template.options": "Options",
        "template.required": "required",
        "template.title": "Title",
        "template.type": "Type"
    },
    "play": {
        "app.action.menu": "Menu",
        "app.action.publishPreview": "Publish preview",
        "app.action.run": "Run",
        "app.action.stop": "Stop",
        "app.action.toc": "Table of contents",
        "app.dialog.allFiles": "All Files",
        "app.dialog.openMarkdownFile": "Open Markdown File",
        "app.error.dropMarkdownOnly": "Drop a Markdown file (.md)",
        "app.error.openExternalFailed": "Failed to open externally",
        "app.error.openFileFailed": "Failed to open file",
        "app.error.openPublishPreviewFailed": "Failed to open publish preview",
        "app.error.publishPreviewArtifactMissing": "Publish artifact was not found. Publish this document from the desktop app first.",
        "app.error.publishPreviewGatewayRequired": "Remote publish preview requires an Engine Gateway connection first.",
        "app.error.publishPreviewMissingPath": "The current document has no file path, so publish preview cannot be opened.",
        "app.error.publishPreviewReadFailed": "Failed to read publish preview file.",
        "app.error.readFileFailed": "Failed to read file",
        "app.error.refreshFailed": "Refresh failed",
        "app.runAllProgress": "Running {current}/{total}",
        "common.cancel": "Cancel",
        "common.close": "Close",
        "common.refresh": "Refresh",
        "common.retry": "Retry",
        "definitionConfig.applyChanges": "Apply changes",
        "definitionConfig.discard": "Discard changes",
        "definitionConfig.noDefinition": "Definition not found",
        "definitionConfig.prompt.directoryPath": "Enter directory path:",
        "definitionConfig.prompt.filePath": "Enter file path:",
        "definitionConfig.visualEditor": "Visual",
        "drawer.closeTab": "Close {title}",
        "drawer.emptyFiles": "No open files",
        "drawer.engineConnected": "Engine connected",
        "drawer.engineDisconnected": "Engine disconnected",
        "drawer.error.openFileFailed": "Unable to open the file. It may have been moved or deleted.",
        "drawer.error.openWorkspaceFailed": "Unable to open the workspace. It may have been moved or you may not have permission.",
        "drawer.goHome": "Go home",
        "drawer.home": "Home",
        "drawer.openTabs": "Open",
        "drawer.plugins": "Plugins",
        "drawer.recentFiles": "Recently Opened",
        "drawer.remove": "Remove",
        "drawer.removeNamed": "Remove {name}",
        "drawer.tool.connect": "Connect",
        "drawer.tool.local": "Local",
        "drawer.tool.open": "Open",
        "drawer.tool.search": "Search",
        "drawer.tool.sync": "Sync",
        "drawer.tool.workspace": "Workspace",
        "drawer.workspaceHistory": "Workspace History",
        "engineConnector.connect": "Connect",
        "engineConnector.connected": "Connected",
        "engineConnector.connectFailed": "Unable to connect to Engine Gateway",
        "engineConnector.connectFailedWithDetail": "Connection failed: {detail}",
        "engineConnector.connecting": "Connecting...",
        "engineConnector.clearGatewayAddress": "Clear Gateway address",
        "engineConnector.disconnect": "Disconnect",
        "engineConnector.disconnected": "Disconnected",
        "engineConnector.discoveredGateways": "Gateways on this network",
        "engineConnector.discoveryEmpty": "No Gateways found. You can enter an address below.",
        "engineConnector.discoveryFailed": "Discovery failed: {detail}",
        "engineConnector.discoveryRefresh": "Refresh",
        "engineConnector.discoveryScanning": "Searching the local network...",
        "engineConnector.gatewayAddress": "Gateway Address",
        "engineConnector.runOnDesktopPrefix": "Run",
        "engineConnector.runOnDesktopSuffix": "on your computer to start Gateway",
        "engineConnector.subtitle": "Connect to Engine Gateway to enable execution and AI features",
        "engineConnector.title": "Engine Connection",
        "execution.completed": "Execution completed",
        "execution.completedWithDuration": "Completed ({duration})",
        "execution.detail": "Details",
        "execution.failed": "Execution failed",
        "errorBoundary.clearPluginCacheAndReload": "Clear plugin cache and reload",
        "errorBoundary.reload": "Reload",
        "errorBoundary.title": "Something went wrong",
        "home.action.connectEngine": "Connect Engine",
        "home.action.connectEngineDetail": "Choose or scan a device",
        "home.action.openDocument": "Open Document",
        "home.action.openDocumentDetail": "Choose a local Markdown file",
        "home.action.search": "Search",
        "home.action.searchRequiresEngine": "Available after connecting Engine",
        "home.action.sync": "Sync",
        "home.action.syncDetail": "Push content",
        "home.action.workspace": "Workspace",
        "home.action.workspaceDetail": "Browse files from the connected Engine",
        "home.action.workspaceSearch": "Workspace Search",
        "home.empty.description": "Open a file or connect Engine to continue",
        "home.empty.title": "No documents",
        "home.error.mdspaceGatewayRequired": "Opening an mdspace requires connecting to Engine Gateway first.",
        "home.error.openFileFailed": "Failed to open file",
        "home.openTabs": "Open",
        "home.recentFiles": "Recently Opened",
        "home.source.local": "Local",
        "home.source.publishPreview": "Publish preview",
        "home.source.push": "Push",
        "home.source.remote": "Remote",
        "htmlPreview.openExternal": "Open externally",
        "fileList.closeTab": "Close {title}",
        "fileList.pushDocument": "Pushed document",
        "fileList.title": "Open Documents",
        "pairing.cancel": "Cancel pairing",
        "pairing.instructions": "Enter the following digits in Editor to complete pairing",
        "pairing.requestFromPrefix": "Connection request from",
        "pairing.requestFromSuffix": "",
        "pairing.title": "Pairing Code",
        "plugin.category.ai": "AI",
        "plugin.category.aiTooling": "AI Tooling",
        "plugin.category.composition": "Composition",
        "plugin.category.data": "Data",
        "plugin.category.database": "Database",
        "plugin.category.devops": "DevOps",
        "plugin.category.devtool": "Dev Tool",
        "plugin.category.file": "File",
        "plugin.category.fileOps": "Files",
        "plugin.category.git": "Git",
        "plugin.category.integration": "Integration",
        "plugin.category.layout": "Layout",
        "plugin.category.media": "Media",
        "plugin.category.other": "Other",
        "plugin.category.productivity": "Productivity",
        "plugin.category.runtime": "Runtime",
        "plugin.category.utility": "Utility",
        "plugin.category.visualization": "Visualization",
        "pluginManager.authorLabel": "Author:",
        "pluginManager.cached.daysAgo": "{count} days ago",
        "pluginManager.cached.hoursAgo": "{count} hours ago",
        "pluginManager.cached.label": "Cached",
        "pluginManager.cached.minutesAgo": "{count} minutes ago",
        "pluginManager.cached.now": "Just now",
        "pluginManager.clearCache": "Clear cache",
        "pluginManager.clearSearch": "Clear search",
        "pluginManager.clearing": "Clearing...",
        "pluginManager.empty": "No loaded plugins",
        "pluginManager.loadedCount": "{count} plugins loaded",
        "pluginManager.noMatches": "No matching plugins",
        "pluginManager.renderBlock": "block",
        "pluginManager.renderInline": "inline",
        "pluginManager.renderLabel": "Render:",
        "pluginManager.searchPlaceholder": "Search plugins...",
        "pluginManager.title": "Plugin Manager",
        "remoteFile.emptyDirectory": "This directory is empty",
        "remoteFile.error.fetchRootsFailed": "Failed to fetch directory list",
        "remoteFile.error.pathOutsideRoots": "This path is outside the allowed directory roots",
        "remoteFile.error.readDirectoryFailed": "Failed to read directory",
        "remoteFile.error.readFileFailed": "Failed to read file",
        "remoteFile.error.workspaceUnsupported": "Opening workspace files is not supported in this version",
        "remoteFile.goUp": "Go up",
        "remoteFile.location": "Location",
        "remoteFile.markdownFiles": "Markdown Files",
        "remoteFile.noAccessibleRoots": "The current Gateway does not expose any accessible directory roots.",
        "remoteFile.otherFiles": "Other Files",
        "remoteFile.title": "Remote Files",
        "search.error.gatewayRequired": "Workspace Search requires an Engine Gateway connection first",
        "search.error.openResultFailed": "Failed to open search result",
        "search.requiresEngineDescription": "Workspace Search uses Gateway to scan remote workspace files.",
        "search.requiresEngineTitle": "Connect Engine first",
        "store.document": "Document",
        "store.publishPreviewTitle": "{name} · Publish preview",
        "store.pushLabel": "Push",
        "sync.broadcast": "Broadcast",
        "sync.description.live": "Editor is pushing documents in real time",
        "sync.description.off": "After enabling it, Editor can discover this device and push documents.",
        "sync.description.waitingSelection": "Select this device in Editor to start previewing.",
        "sync.editor": "Editor",
        "sync.localDevice": "This device",
        "sync.running": "Running",
        "sync.servicePort": "Service port",
        "sync.startBroadcast": "Start broadcast",
        "sync.status.connected": "Connected",
        "sync.status.live": "Live sync",
        "sync.status.off": "Sync is off",
        "sync.status.waitingEditor": "Waiting for Editor",
        "sync.stopBroadcast": "Stop broadcast",
        "sync.stopped": "Stopped",
        "sync.subtitle": "Enable broadcast so Editor can discover this device and push documents",
        "sync.thisDevice": "This device",
        "sync.title": "Sync with Editor",
        "toc.empty.description": "No headings were found in this document",
        "toc.empty.title": "No table of contents",
        "toc.title": "Table of contents",
        "tabBar.closeTab": "Close {title}",
        "viewer.connected": "Connected",
        "viewer.engineConnected": "Engine connected",
        "viewer.syncing": "Syncing",
        "viewer.waitingPush": "Waiting for push",
        "workspace.folderCount": "{count} folders",
        "workspace.title": "Workspace",
        "workspaceTree.loading": "Loading workspace...",
        "workspaceTree.noWorkspace": "Engine has no open workspace. Use Remote below to choose an .mdspace file.",
        "workspaceTree.openFileFailed": "Failed to open file",
        "workspaceTree.refresh": "Refresh workspace"
    },
    "pluginSdk": {
        "collapsiblePre.expandAll": "Expand all",
        "collapsiblePre.expandMore": "Expand more",
        "collapsiblePre.lineCount": "{visible} / {total} lines",
        "comboSelect.noMatch": "No match for \"{query}\"",
        "comboSelect.noOptions": "No options available",
        "comboSelect.placeholder": "Select...",
        "comboSelect.search": "Search...",
        "common.collapse": "Collapse",
        "common.expand": "Expand",
        "continuationTarget.kind.content": "Content",
        "continuationTarget.kind.definition": "Definition",
        "continuationTarget.kind.for": "For loop",
        "continuationTarget.kind.fragment": "Fragment",
        "continuationTarget.kind.importDocument": "Imported document",
        "continuationTarget.placeholder": "Select mounted content...",
        "engineMount.requiresHost": "EngineMount requires a host environment",
        "jsonTree.copyAsJson": "Copy as JSON",
        "jsonTree.copyMinifiedJson": "Copy minified JSON",
        "jsonTree.copyPath": "Copy path",
        "jsonTree.copyValue": "Copy value",
        "lsp.error.commandMissing": "{command} was not found",
        "lsp.error.crashed": "LSP crashed",
        "lsp.error.serverCrashed": "{command} crashed",
        "lsp.error.serverExited": "{command} exited",
        "lsp.error.serverExitedWithReason": "{command} exited: {reason}",
        "lsp.error.sqlsMissingFts5": "sqls is missing FTS5 support",
        "lsp.nextProblem": "Next problem (F8)",
        "lsp.noProblems": "No problems",
        "lsp.quickFix": "Quick fix",
        "lsp.quickFixShortcut": "Quick fix (Mod+.)",
        "lsp.resizeEditor": "Drag to resize editor height",
        "lsp.status.connected": "{label} connected",
        "lsp.status.connecting": "{label} connecting",
        "lsp.status.disconnected": "LSP disconnected",
        "lsp.status.error": "{label} error",
        "lsp.status.off": "LSP off",
        "lsp.status.startFailed": "{label} failed to start: {error}",
        "pty.close": "Close terminal",
        "pty.closedMessage": "[session closed]",
        "pty.endedMessage": "[session ended]",
        "pty.livenessFailedMessage": "[session check failed]",
        "pty.missingSessionMessage": "[session not found, restart terminal]",
        "pty.requiresTerminalSidecar": "PTY mode requires terminal sidecar support",
        "pty.restart": "Restart terminal",
        "pty.status.active": "● Active",
        "pty.status.connecting": "◌ Connecting",
        "pty.status.ended": "○ Ended",
        "pty.status.error": "✗ Error",
        "pty.title": "PTY Session",
        "referenceBrowser.declaredInputs": "Declared inputs",
        "referenceBrowser.emptyImportDocument": "This imported document has no referenceable definitions or content",
        "referenceBrowser.group.contentRefs": "Content references",
        "referenceBrowser.group.documentRefs": "Document references",
        "referenceBrowser.group.importDocuments": "Imported documents",
        "referenceBrowser.group.scopeVariables": "Scope variables",
        "referenceBrowser.group.templateInputs": "Template inputs",
        "referenceBrowser.group.unitIdentity": "Unit identity",
        "referenceBrowser.inputParam": "input/ parameter",
        "referenceBrowser.invalidParamName": "Parameter names can only contain letters, numbers, underscores, and hyphens",
        "referenceBrowser.noDocumentAssets": "The current document has no available assets. Add an Assets Package in Explorer and import files first.",
        "referenceBrowser.noImportAssets": "This imported document has no available assets. Import files in that document's Assets Package first.",
        "referenceBrowser.noRefs": "No references available",
        "referenceBrowser.noUnits": "No units available",
        "referenceBrowser.paramName": "Parameter name",
        "referenceBrowser.runContentForOutput": "Run this content block to browse inner outputs",
        "referenceBrowser.runSourceForFields": "Data source has not run. Run it first to preview field structure.",
        "referenceBrowser.selectContent": "Select a content block to browse body or inner output",
        "referenceBrowser.selectDefinition": "Select a document instance to browse output fields",
        "referenceBrowser.selectImportDocument": "Select a document import to browse its definitions and content",
        "referenceBrowser.selectRef": "Select reference...",
        "referenceBrowser.selectScopeVariable": "Select a scope variable to browse fields",
        "referenceBrowser.selectSource": "Select reference source...",
        "referenceBrowser.selectSourceFirst": "Select a reference source from the dropdown first",
        "referenceBrowser.use": "Use",
        "refOrValue.switchToManual": "Switch to manual mode",
        "refOrValue.switchToRef": "Switch to reference mode",
        "resizableSidebar.title": "Drag to resize sidebar width, double-click to reset",
        "resizableViewport.title": "Drag to resize height"
    }
}
